// import React, { useEffect, useMemo, useState, useRef } from 'react';
// import {
//   Box,
//   Paper,
//   TextField,
//   InputAdornment,
//   IconButton,
//   Typography,
//   Stack,
//   Button,
//   Divider,
//   Chip,
//   Tooltip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Collapse,
//   Popover,
//   ButtonBase,
//   Switch,
//   Checkbox,
//   Grid,
// } from '@mui/material';
// import { useLocation } from 'react-router-dom';
// import { styled, keyframes } from '@mui/material/styles';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// // --- ICONS ---
// import SearchIcon from '@mui/icons-material/Search';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import EjectOutlinedIcon from '@mui/icons-material/EjectOutlined';
// import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import CloseIcon from '@mui/icons-material/Close';
// import LinkIcon from '@mui/icons-material/Link';
// import copy from 'copy-to-clipboard';
// import { GMailIcon, WhatsAppIcon } from '../../components/SvgIcon/SvgIcon';
// import {
//   WhatsappShareButton,
//   TelegramShareButton,
//   FacebookShareButton,
//   LinkedinShareButton,
// } from 'react-share';
// import FacebookIcon from '@mui/icons-material/Facebook';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import axios from 'axios';
// import { useDispatch, useSelector } from 'react-redux';
// import { API_URL } from '../../config/apiUrl';
// import { VariableSizeList as List } from 'react-window';
// import CustomDateRangePicker from '../../common/datePicker/Daterangepicker';
// import dayjs from 'dayjs';
// // import { useDocumentPiP } from "../../hooks/useDocumentPiP";
// import { openSnackbar } from '../../redux/actions/snackbarAction';
// import { useTranscriber } from '../../hooks/useTranscriber';
// import { isMobile, isTablet } from 'react-device-detect';

// // --- MOCK DATA (to replicate the UI) ---

// // --- DATA PROCESSING UTILITY ---
// // Groups meetings by dateLabel and ensures "Recording Now" is first
// const groupMeetings = data => {
//   const groups = data.reduce((acc, meeting) => {
//     const key = meeting.dateLabel;
//     if (!acc[key]) {
//       acc[key] = [];
//     }
//     acc[key].push(meeting);
//     return acc;
//   }, {});

//   const sortedKeys = Object.keys(groups).sort((a, b) => {
//     const getDate = str => {
//       const label = str.split(', ')[0];
//       const datePart = str.split(', ')[1];
//       const [day, month, year] = datePart.split('/').map(Number);
//       return {
//         label,
//         date: new Date(2000 + year, month - 1, day),
//       };
//     };

//     const aData = getDate(a);
//     const bData = getDate(b);

//     // Priority: Today (1), Yesterday (2), Others (3)
//     const getPriority = label => {
//       if (label === 'Today') return 1;
//       if (label === 'Yesterday') return 2;
//       return 3;
//     };

//     const aPriority = getPriority(aData.label);
//     const bPriority = getPriority(bData.label);

//     if (aPriority !== bPriority) return aPriority - bPriority;
//     // return aData.date - bData.date;
//     return bData.date - aData.date;
//   });

//   return sortedKeys.map(key => ({
//     dateLabel: key,
//     meetings: groups[key],
//   }));
// };

// // --- STYLED COMPONENTS ---
// // Blinking animation for the "Recording Now" indicator
// const blinkAnimation = keyframes`
//   50% {
//     opacity: 0;
//   }
// `;

// const BlinkingDot = styled('div')(({ theme }) => ({
//   height: 5,
//   width: 5,
//   borderRadius: '50%',
//   backgroundColor: 'var(--primary-300)',
//   animation: `${blinkAnimation} 1.5s linear infinite`,
// }));

// // --- CHILD COMPONENT: MeetingItem ---
// const MeetingItem = ({
//   meeting,
//   handleSoftDelete,
//   props,
//   isRecord,
//   hasOngoingMeeting,
//   dispatch,
//   meetingHistoryData,
//   resetAll,
//   isSelected,
//   onSelectChange,
//   showCheckbox = false,
//   transScriptSession,
// }) => {
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [hoverDisplay, setHoverDisplay] = useState(false);
//   const [openDeleteDialogue, setOpenDeleteDialogue] = useState(false);
//   const [shareUrl, setShareUrl] = useState('');
//   const [isLoadingShare, setIsLoadingShare] = useState(false);
//   const [openShareDialog, setOpenShareDialog] = useState(false);
//   const [copied, setCopied] = useState(false);

//   const handleShareClick = async event => {
//     event.stopPropagation();
//     setIsLoadingShare(true);
//     setOpenShareDialog(true);
//     try {
//       const response = await axios.post(
//         `${API_URL}/api/share`,
//         {
//           recording_id: meeting.id,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${transScriptSession}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );

//       if (response.data && response.data.url) {
//         setShareUrl(response.data.url);
//       } else {
//         dispatch(openSnackbar('error', 'Failed to generate share URL.'));
//         setOpenShareDialog(false);
//       }
//     } catch (error) {
//       // Error sharing meeting
//       dispatch(
//         openSnackbar(
//           'error',
//           error.response?.data?.message ||
//             'Something went wrong while sharing meeting.'
//         )
//       );
//       setOpenShareDialog(false);
//     } finally {
//       setIsLoadingShare(false);
//     }
//   };

//   const handleShareDialogClose = () => {
//     setOpenShareDialog(false);
//     setShareUrl('');
//     setCopied(false);
//   };

//   const handleCopyUrl = () => {
//     if (shareUrl) {
//       const copySuccess = copy(shareUrl);
//       if (copySuccess) {
//         setCopied(true);
//         dispatch(openSnackbar('success', 'URL copied to clipboard!'));
//         setTimeout(() => setCopied(false), 2000);
//       } else {
//         dispatch(openSnackbar('error', 'Failed to copy URL.'));
//       }
//     }
//   };

//   const [popoverAnchor, setPopoverAnchor] = useState(null);
//   const [childMeetingDetails, setChildMeetingDetails] = useState({});

//   const handlePopoverOpen = (event, meetingDetails) => {
//     // event.stopPropagation();
//     setChildMeetingDetails(meetingDetails);
//     setPopoverAnchor(event.currentTarget);
//   };

//   const handlePopoverClose = event => {
//     event.stopPropagation();
//     setChildMeetingDetails({});
//     setPopoverAnchor(null);
//   };
//   const open = Boolean(popoverAnchor);

//   const subject = encodeURIComponent('Check this out!');
//   const body = encodeURIComponent(`Hey, take a look at this:\n\n${shareUrl}`);
//   const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&su=${subject}&body=${body}`;
//   const credits = useSelector(state => state.user.credits);
//   const isResumeDisabled = credits <= 0;
//   const ClickableWrapper = ({ children }) => {
//     return isRecord ? (
//       <Box
//         sx={{
//           width: 'calc(100% - 32px)',
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'start',
//           textAlign: 'left',
//           // px: 2,
//           // py: 1,
//           // borderRadius: 1,
//           justifyContent: 'start',
//           // "&:hover": {
//           //   backgroundColor: "var(--grey-50)",
//           // },
//           // flexWrap: { xs: "wrap", sm: "nowrap" },
//           // gap:{ xs: 0.5, sm: 0 }
//         }}
//       >
//         {children}
//       </Box>
//     ) : (
//       <ButtonBase
//         onClick={() => {
//           setLoading(true);
//           setDetails({
//             meetingDetails: meeting,
//             isResume: false,
//             isDetailsView: true,
//           });
//           navigate(ROUTES.HOME);
//         }}
//         sx={{
//           width: 'calc(100% - 32px)',
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'start',
//           textAlign: 'left',
//           // px: 2,
//           // py: 1,
//           // borderRadius: 1,
//           justifyContent: 'start',
//           // "&:hover": {
//           //   backgroundColor: "var(--grey-50)",
//           // },
//           // flexWrap: { xs: "wrap", sm: "nowrap" },
//           // gap:{ xs: 0.5, sm: 0 }
//         }}
//       >
//         {children}
//       </ButtonBase>
//     );
//   };
//   const meetingDetailsRef = useRef({});

//   const parentDetialsDisplay = () => {
//     var parentDetails = {};
//     if (childMeetingDetails.hasInfo) {
//       var details = meetingHistoryData.apiData.find(
//         data => data.id === childMeetingDetails.parentRecordingId
//       );
//       if (details && Object.keys(details).length > 0) {
//         parentDetails = { ...details };
//       } else {
//         setChildMeetingDetails({});
//         setPopoverAnchor(null);
//         dispatch(
//           openSnackbar(
//             'warning',
//             'Parent meeting details not found. Either meeting was deleted or not found in the selected date range.'
//           )
//         );
//         return;
//       }
//     }

//     return (
//       <Popover
//         open={Boolean(popoverAnchor)}
//         anchorEl={popoverAnchor}
//         onClose={handlePopoverClose}
//         onClick={e => {
//           e.stopPropagation();
//         }}
//         anchorOrigin={{
//           vertical: 'bottom',
//           horizontal: 'center',
//         }}
//         transformOrigin={{
//           vertical: 'top',
//           horizontal: 'center',
//         }}
//         disableRestoreFocus
//         slotProps={{
//           paper: {
//             sx: {
//               width: 210,
//             },
//           },
//         }}
//       >
//         {parentDetails && Object.keys(parentDetails).length > 0 && (
//           <Box py={1} px={1.5}>
//             <Box>
//               <Typography variant="caption" color="grey.400">
//                 Meeting Title
//               </Typography>
//               <Tooltip title={parentDetails.title} arrow>
//                 <Typography
//                   variant="body2"
//                   component="div"
//                   noWrap
//                   fontWeight={500}
//                   color="secondary.main"
//                 >
//                   {parentDetails.title}
//                 </Typography>
//               </Tooltip>
//             </Box>

//             <Box display={'flex'} alignItems={'center'} gap={2}>
//               <Box>
//                 <Typography variant="caption" color="grey.400">
//                   Duration
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   fontWeight={500}
//                   color="text.primary"
//                 >
//                   {parentDetails.duration}
//                 </Typography>
//               </Box>

//               <Box>
//                 <Typography variant="caption" color="grey.400">
//                   Start Time
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   fontWeight={500}
//                   color="text.primary"
//                 >
//                   {parentDetails.startTime}
//                 </Typography>
//               </Box>
//             </Box>

//             <Box>
//               <Typography variant="caption" color="text.secondary">
//                 Date
//               </Typography>
//               <Typography variant="body2" fontWeight={500} color="text.primary">
//                 {parentDetails.dateLabel}
//               </Typography>
//             </Box>
//           </Box>
//         )}
//       </Popover>
//     );
//   };

  // return (
  //   <>
  //     <Paper
  //       // variant="outlined"
  //       sx={{
  //         // py: 1,
  //         px: 2,
  //         backgroundColor: 'var(--grey-0)',
  //         // borderColor: '#e8eef6',
  //         borderRadius: 0,
  //         // borderBottom: "1px solid var(--grey-100)",
  //       }}
  //       elevation={0}
  //     >
  //       <Stack
  //         direction="row"
  //         alignItems="center"
  //         sx={{
  //           width: '100%',
  //           display: 'flex',
  //           alignItems: 'center',
  //           textAlign: 'left',
  //           // px: 2,
  //           // py: 1,
  //           // borderRadius: 1,
  //           justifyContent: 'start',
  //           // "&:hover": {
  //           //   backgroundColor: "var(--grey-50)",
  //           // },
  //           flexWrap: { xs: 'wrap', sm: 'nowrap' },
  //           gap: { xs: 0.5, sm: 0 },
  //         }}
  //       >
  //         {showCheckbox && !isRecord && (
  //           <Checkbox
  //             checked={isSelected || false}
  //             onChange={e => {
  //               e.stopPropagation();
  //               onSelectChange && onSelectChange(meeting.id, e.target.checked);
  //             }}
  //             onClick={e => e.stopPropagation()}
  //             size="small"
  //             sx={{ mr: 1 }}
  //           />
  //         )}
  //         <Box
  //           sx={{
  //             display: 'flex',
  //             alignItems: 'end',
  //             gap: 0.5,
  //             width: { xs: '100%', sm: '250px', md: '270px' },
  //             marginRight: { xs: 'auto', md: 0 },
  //           }}
  //         >
  //           <ClickableWrapper>
  //             {/* Meeting Title */}

  //             <Typography
  //               variant="caption"
  //               color="grey.400"
  //               sx={{ display: 'block' }}
  //             >
  //               Meeting Title
  //             </Typography>

  //             <Tooltip title={meeting.title} arrow>
  //               <Typography
  //                 variant="body2"
  //                 component="div"
  //                 noWrap
  //                 fontWeight={500}
  //                 color="secondary.main"
  //                 width={'100%'}
  //               >
  //                 {meeting.title}
  //               </Typography>
  //             </Tooltip>
  //           </ClickableWrapper>

  //           {meeting.hasInfo && (
  //             <Box
  //               onClick={e => e.stopPropagation()}
  //               sx={{ alignSelf: 'flex-end', marginBottom: '-4px' }}
  //             >
  //               <Tooltip title="Parent Meeting Details" arrow>
  //                 <IconButton
  //                   size="small"
  //                   onClick={e => {
  //                     handlePopoverOpen(e, meeting);
  //                   }}
  //                 >
  //                   <InfoOutlinedIcon color="primary" fontSize="inherit" />
  //                 </IconButton>
  //               </Tooltip>
  //             </Box>
  //           )}
  //           {Boolean(popoverAnchor) && <>{parentDetialsDisplay()}</>}
  //           {/* Info Icon start  */}
  //         </Box>
  //         <Divider
  //           orientation="vertical"
  //           variant="middle"
  //           flexItem
  //           sx={{
  //             mx: 2,
  //             height: 28,
  //             display: { xs: 'none', sm: 'block' },
  //           }}
  //         />

  //         {/* Start Time */}
  //         <Box sx={{ flexShrink: 0, ml: { xs: 'auto', sm: '0' } }}>
  //           <Typography variant="caption" color="grey.400">
  //             Start Time
  //           </Typography>
  //           <Typography variant="body2" fontWeight={500} color="text.primary">
  //             {meeting.startTime}
  //           </Typography>
  //         </Box>
  //         <Divider
  //           orientation="vertical"
  //           variant="middle"
  //           flexItem
  //           sx={{
  //             mx: 2,
  //             height: 28,
  //             display: { xs: 'none', sm: 'block' },
  //           }}
  //         />
  //         {/* Duration */}
  //         <Box sx={{ flexShrink: 0 }}>
  //           <Typography variant="caption" color="grey.400">
  //             Duration
  //           </Typography>
  //           <Typography variant="body2" fontWeight={500} color="text.primary">
  //             {meeting.duration}
  //           </Typography>
  //         </Box>
  //         {!meeting.isRecording && (
  //           <>
  //             <Divider
  //               orientation="vertical"
  //               variant="middle"
  //               flexItem
  //               sx={{
  //                 mx: 2,
  //                 height: 28,
  //                 display: { xs: 'none', sm: 'block' },
  //               }}
  //             />
  //             <Box sx={{ flexShrink: 0, ml: { xs: 'auto', sm: '0' } }}>
  //               <Typography variant="caption" color="grey.400">
  //                 Credits Used
  //               </Typography>
  //               <Typography
  //                 variant="body2"
  //                 fontWeight={500}
  //                 color="text.primary"
  //               >
  //                 {meeting.creditsUsed}
  //               </Typography>
  //             </Box>
  //           </>
  //         )}

  //         {/* Actions */}
  //         <Box
  //           sx={{
  //             display: 'flex',
  //             alignItems: 'center',
  //             gap: 0.5,
  //             width: { xs: '100%', md: 'auto' },
  //             marginLeft: { xs: 0, md: 'auto' },
  //             justifyContent: 'flex-end',
  //           }}
  //         >
  //           {meeting.status === 'transcript' && (
  //             <Chip
  //               variant="outlined"
  //               size="small"
  //               label="Transcript Only"
  //               color="primary"
  //               sx={{
  //                 marginRight: { xs: 'auto', md: 0 },
  //               }}
  //             />
  //           )}
  //           {!meeting.isRecording && (
  //             <>
  //               <Tooltip title="Resume" arrow>
  //                 <IconButton
  //                   size="small"
  //                   disabled={isResumeDisabled}
  //                   onClick={() => {
  //                     if (!hasOngoingMeeting) {
  //                       meetingDetailsRef.current = {
  //                         meetingDetails: meeting,
  //                         isResume: true,
  //                         isDetailsView: false,
  //                       };
  //                       setDialogOpen(true);
  //                     } else {
  //                       dispatch(
  //                         openSnackbar(
  //                           'warning',
  //                           'Please end the ongoing meeting first to create a new meeting.'
  //                         )
  //                       );
  //                     }
  //                   }}
  //                 >
  //                   <EjectOutlinedIcon
  //                     sx={{
  //                       transform: 'rotate(90deg)',
  //                       color: isResumeDisabled
  //                         ? 'text.disabled'
  //                         : 'text.primary',
  //                     }}
  //                   />
  //                 </IconButton>
  //               </Tooltip>
  //               <Tooltip title="Share" arrow>
  //                 <IconButton
  //                   size="small"
  //                   onClick={handleShareClick}
  //                   disabled={isLoadingShare}
  //                 >
  //                   <ShareOutlinedIcon
  //                     fontSize="small"
  //                     sx={{ color: 'text.primary' }}
  //                   />
  //                 </IconButton>
  //               </Tooltip>

  //               {/* Share Dialog */}
  //               <Dialog
  //                 open={openShareDialog}
  //                 onClose={handleShareDialogClose}
  //                 maxWidth="sm"
  //                 fullWidth
  //                 PaperProps={{
  //                   sx: {
  //                     borderRadius: 2,
  //                   },
  //                 }}
  //               >
  //                 <DialogTitle>
  //                   <Box display="flex" alignItems="center" gap={1}>
  //                     <LinkIcon sx={{ color: 'primary.main' }} />
  //                     <Typography
  //                       variant="h6"
  //                       component="span"
  //                       fontWeight={600}
  //                     >
  //                       Share link
  //                     </Typography>
  //                     <IconButton
  //                       aria-label="close"
  //                       onClick={handleShareDialogClose}
  //                       sx={{
  //                         position: 'absolute',
  //                         right: 8,
  //                         top: 8,
  //                         color: 'text.secondary',
  //                       }}
  //                       size="small"
  //                     >
  //                       <CloseIcon />
  //                     </IconButton>
  //                   </Box>
  //                 </DialogTitle>
  //                 <DialogContent>
  //                   {isLoadingShare && !shareUrl ? (
  //                     <Box display="flex" justifyContent="center" py={4}>
  //                       <Typography variant="body2" color="text.secondary">
  //                         Loading share URL...
  //                       </Typography>
  //                     </Box>
  //                   ) : shareUrl ? (
  //                     <Stack spacing={3}>
  //                       {/* URL Section */}
  //                       <Box>
  //                         <Typography
  //                           variant="caption"
  //                           color="text.secondary"
  //                           fontWeight={500}
  //                           sx={{ mb: 1, display: 'block' }}
  //                         >
  //                           URL
  //                         </Typography>
  //                         <Box display="flex" gap={1}>
  //                           <TextField
  //                             fullWidth
  //                             value={shareUrl}
  //                             variant="outlined"
  //                             size="small"
  //                             InputProps={{
  //                               readOnly: true,
  //                               sx: {
  //                                 backgroundColor: 'var(--grey-50)',
  //                                 fontSize: '14px',
  //                               },
  //                             }}
  //                           />
  //                           <Button
  //                             variant="contained"
  //                             color="primary"
  //                             onClick={handleCopyUrl}
  //                             startIcon={<ContentCopyIcon />}
  //                             sx={{
  //                               minWidth: '120px',
  //                               whiteSpace: 'nowrap',
  //                             }}
  //                           >
  //                             {copied ? 'Copied!' : 'Copy link'}
  //                           </Button>
  //                         </Box>
  //                       </Box>

  //                       {/* Share Using Section */}
  //                       <Box>
  //                         <Typography
  //                           variant="caption"
  //                           color="text.secondary"
  //                           fontWeight={500}
  //                           sx={{ mb: 2, display: 'block' }}
  //                         >
  //                           Share using
  //                         </Typography>
  //                         <Grid container spacing={2}>
  //                           <Grid item xs={4} sm={3}>
  //                             <WhatsappShareButton
  //                               url={shareUrl}
  //                               style={{
  //                                 width: '100%',
  //                                 display: 'flex',
  //                                 flexDirection: 'column',
  //                                 alignItems: 'center',
  //                                 gap: 8,
  //                                 padding: '12px',
  //                                 border: '1px solid var(--grey-100)',
  //                                 borderRadius: '8px',
  //                                 backgroundColor: 'transparent',
  //                                 cursor: 'pointer',
  //                                 textDecoration: 'none',
  //                                 transition: 'all 0.2s',
  //                               }}
  //                               onMouseEnter={e => {
  //                                 e.currentTarget.style.backgroundColor =
  //                                   'var(--grey-50)';
  //                               }}
  //                               onMouseLeave={e => {
  //                                 e.currentTarget.style.backgroundColor =
  //                                   'transparent';
  //                               }}
  //                             >
  //                               <WhatsAppIcon sx={{ fontSize: 32 }} />
  //                               <Typography
  //                                 variant="caption"
  //                                 color="text.primary"
  //                               >
  //                                 WhatsApp
  //                               </Typography>
  //                             </WhatsappShareButton>
  //                           </Grid>
  //                           <Grid item xs={4} sm={3}>
  //                             <Box
  //                               component="div"
  //                               // onClick={e => {
  //                               //   e.stopPropagation();
  //                               //   const subject = encodeURIComponent('Check this out!');
  //                               //   const body = encodeURIComponent(
  //                               //     `Hey, take a look at this:\n\n${shareUrl}`
  //                               //   );
  //                               //   window.location.href = `mailto:?subject=${subject}&body=${body}`;
  //                               // }}
  //                               onClick={() => {
  //                                 window.location.href = gmailLink;
  //                               }}
  //                               sx={{
  //                                 width: '100%',
  //                                 display: 'flex',
  //                                 flexDirection: 'column',
  //                                 alignItems: 'center',
  //                                 gap: 1,
  //                                 padding: '12px',
  //                                 border: '1px solid var(--grey-100)',
  //                                 borderRadius: '8px',
  //                                 backgroundColor: 'transparent',
  //                                 cursor: 'pointer',
  //                                 transition: 'all 0.2s',
  //                                 '&:hover': {
  //                                   backgroundColor: 'var(--grey-50)',
  //                                 },
  //                               }}
  //                             >
  //                               <GMailIcon
  //                                 sx={{ fontSize: 32, color: '#EA4335' }}
  //                               />
  //                               <Typography
  //                                 variant="caption"
  //                                 color="text.primary"
  //                               >
  //                                 Email
  //                               </Typography>
  //                             </Box>
  //                           </Grid>
  //                           {/* <Grid item xs={4} sm={3}>
  //                             <Box
  //                               component="div"
  //                               onClick={e => {
  //                                 e.stopPropagation();
  //                                 const copySuccess = copy(shareUrl);
  //                                 if (copySuccess) {
  //                                   dispatch(
  //                                     openSnackbar(
  //                                       'success',
  //                                       'URL copied! You can paste it into Instagram.'
  //                                     )
  //                                   );
  //                                   window.open(
  //                                     'https://www.instagram.com/',
  //                                     '_blank'
  //                                   );
  //                                 } else {
  //                                   dispatch(
  //                                     openSnackbar(
  //                                       'error',
  //                                       'Failed to copy URL.'
  //                                     )
  //                                   );
  //                                 }
  //                               }}
  //                               sx={{
  //                                 width: '100%',
  //                                 display: 'flex',
  //                                 flexDirection: 'column',
  //                                 alignItems: 'center',
  //                                 gap: 1,
  //                                 padding: '12px',
  //                                 border: '1px solid var(--grey-100)',
  //                                 borderRadius: '8px',
  //                                 backgroundColor: 'transparent',
  //                                 cursor: 'pointer',
  //                                 transition: 'all 0.2s',
  //                                 '&:hover': {
  //                                   backgroundColor: 'var(--grey-50)',
  //                                 },
  //                               }}
  //                             >
  //                               <Box
  //                                 component="svg"
  //                                 sx={{
  //                                   width: 32,
  //                                   height: 32,
  //                                   viewBox: '0 0 24 24',
  //                                   fill: 'url(#instagram-gradient)',
  //                                 }}
  //                               >
  //                                 <defs>
  //                                   <linearGradient
  //                                     id="instagram-gradient"
  //                                     x1="0%"
  //                                     y1="0%"
  //                                     x2="100%"
  //                                     y2="100%"
  //                                   >
  //                                     <stop offset="0%" stopColor="#833AB4" />
  //                                     <stop offset="50%" stopColor="#FD1D1D" />
  //                                     <stop offset="100%" stopColor="#FCAF45" />
  //                                   </linearGradient>
  //                                 </defs>
  //                                 <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  //                               </Box>
  //                               <Typography
  //                                 variant="caption"
  //                                 color="text.primary"
  //                               >
  //                                 Instagram
  //                               </Typography>
  //                             </Box>
  //                           </Grid> */}
  //                           {/* <Grid item xs={4} sm={3}>
  //                             <FacebookShareButton
  //                               url={shareUrl}
  //                               style={{
  //                                 width: '100%',
  //                                 display: 'flex',
  //                                 flexDirection: 'column',
  //                                 alignItems: 'center',
  //                                 gap: 8,
  //                                 padding: '12px',
  //                                 border: '1px solid var(--grey-100)',
  //                                 borderRadius: '8px',
  //                                 backgroundColor: 'transparent',
  //                                 cursor: 'pointer',
  //                                 textDecoration: 'none',
  //                                 transition: 'all 0.2s',
  //                               }}
  //                               onMouseEnter={e => {
  //                                 e.currentTarget.style.backgroundColor =
  //                                   'var(--grey-50)';
  //                               }}
  //                               onMouseLeave={e => {
  //                                 e.currentTarget.style.backgroundColor =
  //                                   'transparent';
  //                               }}
  //                             >
  //                               <FacebookIcon
  //                                 sx={{ fontSize: 32, color: '#1877F2' }}
  //                               />
  //                               <Typography
  //                                 variant="caption"
  //                                 color="text.primary"
  //                               >
  //                                 Facebook
  //                               </Typography>
  //                             </FacebookShareButton>
  //                           </Grid> */}
  //                           <Grid item xs={4} sm={3}>
  //                             <LinkedinShareButton
  //                               url={shareUrl}
  //                               style={{
  //                                 width: '100%',
  //                                 display: 'flex',
  //                                 flexDirection: 'column',
  //                                 alignItems: 'center',
  //                                 gap: 8,
  //                                 padding: '12px',
  //                                 border: '1px solid var(--grey-100)',
  //                                 borderRadius: '8px',
  //                                 backgroundColor: 'transparent',
  //                                 cursor: 'pointer',
  //                                 textDecoration: 'none',
  //                                 transition: 'all 0.2s',
  //                               }}
  //                               onMouseEnter={e => {
  //                                 e.currentTarget.style.backgroundColor =
  //                                   'var(--grey-50)';
  //                               }}
  //                               onMouseLeave={e => {
  //                                 e.currentTarget.style.backgroundColor =
  //                                   'transparent';
  //                               }}
  //                             >
  //                               <LinkedInIcon
  //                                 sx={{ fontSize: 32, color: '#0077B5' }}
  //                               />
  //                               <Typography
  //                                 variant="caption"
  //                                 color="text.primary"
  //                               >
  //                                 LinkedIn
  //                               </Typography>
  //                             </LinkedinShareButton>
  //                           </Grid>
  //                           <Grid item xs={4} sm={3}>
  //                             <TelegramShareButton
  //                               url={shareUrl}
  //                               style={{
  //                                 width: '100%',
  //                                 display: 'flex',
  //                                 flexDirection: 'column',
  //                                 alignItems: 'center',
  //                                 gap: 8,
  //                                 padding: '12px',
  //                                 border: '1px solid var(--grey-100)',
  //                                 borderRadius: '8px',
  //                                 backgroundColor: 'transparent',
  //                                 cursor: 'pointer',
  //                                 textDecoration: 'none',
  //                                 transition: 'all 0.2s',
  //                               }}
  //                               onMouseEnter={e => {
  //                                 e.currentTarget.style.backgroundColor =
  //                                   'var(--grey-50)';
  //                               }}
  //                               onMouseLeave={e => {
  //                                 e.currentTarget.style.backgroundColor =
  //                                   'transparent';
  //                               }}
  //                             >
  //                               <Box
  //                                 component="svg"
  //                                 sx={{
  //                                   width: 32,
  //                                   height: 32,
  //                                   viewBox: '0 0 24 24',
  //                                   fill: '#0088cc',
  //                                 }}
  //                               >
  //                                 <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.16c-.169 1.858-.896 6.728-.896 6.728-.5 2.718-1.231 3.27-1.924 3.349-.866.096-1.523-.603-2.361-1.181-1.308-.873-2.048-1.415-3.316-2.27-1.47-1.03-1.493-1.597 1.107-3.445 2.577-1.834 3.602-2.976 4.096-3.359.248-.191.569-.339.924-.353.301-.012 5.611-.229 5.611-.229l1.568-2.05-1.855.043z" />
  //                               </Box>
  //                               <Typography
  //                                 variant="caption"
  //                                 color="text.primary"
  //                               >
  //                                 Telegram
  //                               </Typography>
  //                             </TelegramShareButton>
  //                           </Grid>
  //                         </Grid>
  //                       </Box>
  //                     </Stack>
  //                   ) : null}
  //                 </DialogContent>
  //               </Dialog>
  //               <Tooltip title="Delete" arrow>
  //                 <IconButton
  //                   size="small"
  //                   onMouseEnter={() => {
  //                     setHoverDisplay(true);
  //                   }}
  //                   onMouseLeave={() => {
  //                     setHoverDisplay(false);
  //                   }}
  //                   onClick={() => {
  //                     setOpenDeleteDialogue(true);
  //                   }}
  //                 >
  //                   <DeleteOutlineIcon
  //                     fontSize="small"
  //                     sx={{ color: 'error.main' }}
  //                   />
  //                 </IconButton>
  //               </Tooltip>
  //             </>
  //           )}
  //         </Box>
  //       </Stack>
  //     </Paper>

//       <Dialog
//         open={openDeleteDialogue}
//         onClose={() => setOpenDeleteDialogue(false)}
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle>
//           <Typography
//             variant="subtitle1"
//             component={'span'}
//             color="text.primary"
//           >
//             Are you sure you want to continue?
//           </Typography>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="text.primary">
//             {/* {`${meeting?.title} will be deleted.`} */}
//             {
//               <>
//                 <strong>{meeting?.title}</strong> will be deleted.
//               </>
//             }
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() => {
//               setOpenDeleteDialogue(false);
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             color="error"
//             variant="contained"
//             onClick={() => {
//               handleSoftDelete(meeting?.id);
//               setOpenDeleteDialogue(false);
//             }}
//           >
//             DELETE
//           </Button>
//         </DialogActions>
//       </Dialog>
//       <Dialog
//         open={dialogOpen}
//         onClose={() => setDialogOpen(false)}
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle>
//           <Typography
//             variant="subtitle1"
//             component={'span'}
//             color="text.primary"
//           >
//             Are you sure you want to continue?
//           </Typography>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="text.primary">
//             This will start a new meeting from where you left off.
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() => {
//               setDialogOpen(false);
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             color="primary"
//             variant="contained"
//             onClick={() => {
//               resetAll();
//               setLoading(true);
//               setDetails(meetingDetailsRef.current);
//               navigate(ROUTES.HOME);
//               setDialogOpen(false);
//             }}
//           >
//             Resume
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };





// // --- MAIN COMPONENT ---
// export default function TranscriberHistory(props) {
//   const transScriptSession = useSelector(
//     state => state.sessionDetail.transScriptSession
//   );
//   const dispatch = useDispatch();
//   const [triggerMeetingHistoryCall, setTriggerMeetingHistoryCall] =
//     useState(false);
//   const [meetingHistoryData, setMeetingHistoryData] = useState({ apiData: [] });
//   const [ongoingMeeting, setOngoingMeeting] = useState({});
//   const currentDate = dayjs();
//   const [dataExists, setDataExists] = useState(false);
//   const [transcriptOnlyToggle, setTranscriptOnlyToggle] = useState(false);
//   const [selectedMeetings, setSelectedMeetings] = useState(new Set());
//   const [openBulkDeleteDialog, setOpenBulkDeleteDialog] = useState(false);
//   const { resetAll } = useTranscriber();
//   // PiP functionality
//   // const { isPiPSupported, isPiPOpen, pipWindow, openPiP, closePiP } =
//   //   useDocumentPiP();
//   const location = useLocation();

//   const [dateValue, setDateValue] = useState([
//     dayjs(currentDate.subtract(365, 'day')),
//     currentDate,
//   ]);
//   const current_meeting = useSelector(state => state.currentMeetingDetails);

//   const groupedMeetingData = useMemo(() => {
//     var data = meetingHistoryData.apiData;
//     if (meetingHistoryData.hasOwnProperty('searchResult')) {
//       data = meetingHistoryData.searchResult;
//     }
//     if (transcriptOnlyToggle) {
//       data = data.filter(ele => ele.status === 'transcript');
//     }
//     if (data && typeof data === 'object' && data.length > 0) {
//       return groupMeetings(data);
//     } else {
//       return [];
//     }
//   }, [meetingHistoryData, transcriptOnlyToggle]);

//   // Clear selections when filters change
//   useEffect(() => {
//     setSelectedMeetings(new Set());
//   }, [transcriptOnlyToggle]);

//   const [expandedGroups, setExpandedGroups] = useState(() => {
//     const initial = {};
//     groupedMeetingData.forEach(group => {
//       initial[group.dateLabel] = true;
//     });
//     return initial;
//   });

//   const expandAll = () => {
//     const allExpanded = {};
//     groupedMeetingData.forEach(group => {
//       allExpanded[group.dateLabel] = true;
//     });
//     setExpandedGroups(allExpanded);
//     listRef.current?.resetAfterIndex(0);
//   };

//   useEffect(() => {
//     expandAll();
//   }, [groupedMeetingData]);

//   const listRef = useRef();

//   useEffect(() => {
//     if (isOnHistoryRoute && transScriptSession) {
//       fetchMeetingHistory(dateValue);
//     }
//     setTranscriptOnlyToggle(false);
//     setSelectedMeetings(new Set());
//   }, [isOnHistoryRoute, transScriptSession]);

//   useEffect(() => {
//     if (isOnHistoryRoute) {
//       var obj = {
//         id: current_meeting?.id,
//         isRecording: current_meeting.isRecording,
//         title: current_meeting.meetingTitle,
//         duration: formatTime(current_meeting.recordingTime),
//         startTime: current_meeting.start_time,
//         dateLabel: current_meeting.isRecording ? 'Recording Now' : '',
//         creditsUsed: current_meeting.credits_used,
//       };

//       if (
//         details.hasOwnProperty('meetingDetails') &&
//         Object.keys(details.meetingDetails).length > 0
//       ) {
//         obj['hasInfo'] = true;
//         obj['infoDetails'] = details.meetingDetails;
//       }

//       setOngoingMeeting(obj);
//     }
//   }, [isOnHistoryRoute, current_meeting]);

//   useEffect(() => {
//     if (transScriptSession && triggerMeetingHistoryCall) {
//       fetchMeetingHistory(dateValue);
//     }
//   }, [triggerMeetingHistoryCall]);

//   const fetchMeetingHistory = async dateRange => {
//     const url = `${API_URL}/api/history?start_date=${dateRange[0].format(
//       'DD-MM-YYYY'
//     )}&end_date=${dateRange[1].format('DD-MM-YYYY')}`;
//     setLoading(true);
//     try {
//       const value = await axios.get(url, {
//         headers: {
//           Authorization: `Bearer ${transScriptSession}`,
//         },
//       });
//       if (value.data.length === 0) {
//         setDataExists(false);
//         return;
//       }
//       setDataExists(true);
//       var data = value.data.map(ele => {
//         var dateTime = formatDateTime(ele.date);
//         var obj = {
//           id: ele.id,
//           isRecording: false,
//           title: ele.title,
//           duration: formatDuration(ele.duration),
//           startTime: dateTime[1],
//           dateLabel: dateTime[0],
//           creditsUsed: ele.credits_used,
//           hasInfo: Boolean(ele.parent_recording_id),
//           status: Boolean(ele.has_mom) ? 'full' : 'transcript',
//           infoDetails: {},
//           parentRecordingId: ele.parent_recording_id,
//         };
//         return obj;
//       });
//       if (current_meeting.isRecording) {
//         data = data.filter(
//           ele => ele.id - 0 !== current_meeting.meeting_id - 0
//         );
//       }
//       setMeetingHistoryData({ apiData: data });
//       // setOngoingMeeting(data.length > 0 ? data[0] : {});
//       setTriggerMeetingHistoryCall(false);
//       setSelectedMeetings(new Set());
//     } catch (err) {
//       dispatch(
//         openSnackbar(
//           'error',
//           'Something went wrong while fetching meeting list.'
//         )
//       );
//       // Error while fetching meeting history
//       setTriggerMeetingHistoryCall(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSearch = value => {
//     var data = meetingHistoryData.apiData.filter(row => {
//       var search = row.title.toLowerCase();
//       return search.includes(value.toLowerCase()) && !row.isRecording;
//     });
//     setMeetingHistoryData(prev => ({ ...prev, ...{ searchResult: data } }));
//     if (!value || value.trim() === '') {
//       setSelectedMeetings(new Set());
//     }
//   };

//   const handleSoftDelete = async meetingId => {
//     const url = `${API_URL}/api/history`;
//     setLoading(true);
//     try {
//       const value = await axios.delete(url, {
//         headers: {
//           Authorization: `Bearer ${transScriptSession}`,
//         },
//         data: {
//           recording_ids: [meetingId],
//           // recover: true,
//         },
//       });
//       dispatch(openSnackbar('success', 'Meeting Deleted.'));
//       setTriggerMeetingHistoryCall(true);
//     } catch (err) {
//       // Error while deleting meeting
//       dispatch(
//         openSnackbar('error', 'Something went wrong while deleting meeting.')
//       );
//       setTriggerMeetingHistoryCall(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleBulkDelete = async () => {
//     const meetingIds = Array.from(selectedMeetings);
//     if (meetingIds.length === 0) return;

//     setLoading(true);
//     try {
//       // Single API call with all recording IDs for soft delete
//       await axios.delete(`${API_URL}/api/history`, {
//         headers: {
//           Authorization: `Bearer ${transScriptSession}`,
//           'Content-Type': 'application/json',
//         },
//         data: {
//           recording_ids: meetingIds,
//         },
//       });

//       dispatch(
//         openSnackbar(
//           'success',
//           `${meetingIds.length} meeting(s) deleted successfully.`
//         )
//       );
//       setSelectedMeetings(new Set());
//       setOpenBulkDeleteDialog(false);
//       setTriggerMeetingHistoryCall(true);
//     } catch (err) {
//       // Error while deleting meetings
//       dispatch(
//         openSnackbar('error', 'Something went wrong while deleting meetings.')
//       );
//       setTriggerMeetingHistoryCall(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSelectMeeting = (meetingId, isSelected) => {
//     setSelectedMeetings(prev => {
//       const newSet = new Set(prev);
//       if (isSelected) {
//         newSet.add(meetingId);
//       } else {
//         newSet.delete(meetingId);
//       }
//       return newSet;
//     });
//   };

//   const handleSelectAll = (meetings, isSelected) => {
//     setSelectedMeetings(prev => {
//       const newSet = new Set(prev);
//       if (isSelected) {
//         meetings.forEach(meeting => {
//           if (!meeting.isRecording) {
//             newSet.add(meeting.id);
//           }
//         });
//       } else {
//         meetings.forEach(meeting => {
//           newSet.delete(meeting.id);
//         });
//       }
//       return newSet;
//     });
//   };

//   // Get all meetings (excluding recording now)
//   const getAllMeetings = useMemo(() => {
//     return groupedMeetingData.flatMap(group => group.meetings);
//   }, [groupedMeetingData]);

//   const allMeetingsSelected =
//     getAllMeetings.length > 0 &&
//     getAllMeetings.every(
//       meeting => meeting.isRecording || selectedMeetings.has(meeting.id)
//     );

//   const someMeetingsSelected =
//     getAllMeetings.some(
//       meeting => !meeting.isRecording && selectedMeetings.has(meeting.id)
//     ) && !allMeetingsSelected;

//   const virtualRows = useMemo(() => {
//     return groupedMeetingData.flatMap(({ dateLabel, meetings }) => {
//       const rows = [{ type: 'header', dateLabel, meetings }];
//       if (expandedGroups[dateLabel]) {
//         rows.push(
//           ...meetings.map(meeting => ({
//             type: 'item',
//             dateLabel,
//             meeting,
//           }))
//         );
//       }
//       return rows;
//     });
//   }, [groupedMeetingData, expandedGroups]);

//   const Row = ({ index, style, data }) => {
//     const {
//       data: listData,
//       isOngoing,
//       selectedMeetings,
//       handleSelectMeeting,
//       handleSelectAll,
//     } = data;

//     const row = listData[index];

//     if (row.type === 'header') {
//       const isExpanded = expandedGroups[row.dateLabel];
//       const groupMeetings = row.meetings || [];
//       const nonRecordingMeetings = groupMeetings.filter(m => !m.isRecording);
//       const selectedSet = selectedMeetings || new Set();
//       const groupSelectedCount = nonRecordingMeetings.filter(m =>
//         selectedSet.has(m.id)
//       ).length;
//       const allGroupSelected =
//         nonRecordingMeetings.length > 0 &&
//         groupSelectedCount === nonRecordingMeetings.length;
//       const someGroupSelected =
//         groupSelectedCount > 0 &&
//         groupSelectedCount < nonRecordingMeetings.length;

//       return (
//         <Box
//           style={style}
//           sx={{
//             px: 2,
//             py: 0.2,
//             background: 'var(--grey-50)',
//             borderTop: '1px solid var(--grey-100)',
//             borderBottom: '1px solid var(--grey-100)',
//             cursor: 'pointer',
//           }}
//         >
//           <Box display="flex" alignItems="center" gap={1}>
//             {nonRecordingMeetings.length > 0 && (
//               <Checkbox
//                 checked={allGroupSelected}
//                 indeterminate={someGroupSelected}
//                 onChange={e => {
//                   e.stopPropagation();
//                   handleSelectAll(groupMeetings, e.target.checked);
//                 }}
//                 onClick={e => e.stopPropagation()}
//                 size="small"
//               />
//             )}
//             <Typography
//               variant="caption"
//               fontWeight={500}
//               onClick={() => {
//                 setExpandedGroups(prev => {
//                   const updated = {
//                     ...prev,
//                     [row.dateLabel]: !prev[row.dateLabel],
//                   };

//                   // Reset list heights after DOM updates
//                   setTimeout(() => {
//                     listRef.current?.resetAfterIndex(0);
//                   }, 0);

//                   return updated;
//                 });
//               }}
//               sx={{ flex: 1 }}
//             >
//               {row.dateLabel}
//               {nonRecordingMeetings.length > 0 && groupSelectedCount > 0 && (
//                 <Typography
//                   component="span"
//                   variant="caption"
//                   sx={{ ml: 1, color: 'text.secondary' }}
//                 >
//                   ({groupSelectedCount})
//                 </Typography>
//               )}
//             </Typography>
//             <Tooltip title={isExpanded ? 'Collapse' : 'Expand'} arrow>
//               <IconButton
//                 size="small"
//                 onClick={e => {
//                   e.stopPropagation();
//                   setExpandedGroups(prev => {
//                     const updated = {
//                       ...prev,
//                       [row.dateLabel]: !prev[row.dateLabel],
//                     };

//                     // Reset list heights after DOM updates
//                     setTimeout(() => {
//                       listRef.current?.resetAfterIndex(0);
//                     }, 0);

//                     return updated;
//                   });
//                 }}
//               >
//                 <ExpandMoreIcon
//                   sx={{
//                     transform: expandedGroups[row.dateLabel]
//                       ? 'rotate(0deg)'
//                       : 'rotate(-90deg)',
//                     transition: 'transform 0.2s ease-in-out',
//                   }}
//                 />
//               </IconButton>
//             </Tooltip>
//           </Box>
//         </Box>
//       );
//     }

//     // Meeting item row
//     return (
//       <div
//         style={{
//           ...style,
//           transition: 'all 0.3s ease-in-out',
//           borderBottom: '1px solid var(--grey-100)',
//           display: 'flex',
//           alignItems: 'center',
//           width: '100%',
//         }}
//         className="meeting-item-test"
//       >
//         <Collapse in={true} timeout="auto" sx={{ width: '100%' }}>
//           {/* <Box sx={{ px: 2 }}> */}
//           <MeetingItem
//             meeting={row.meeting}
//             handleSoftDelete={handleSoftDelete}
//             props={props}
//             isRecord={false}
//             hasOngoingMeeting={isOngoing}
//             dispatch={dispatch}
//             meetingHistoryData={meetingHistoryData}
//             resetAll={resetAll}
//             isSelected={
//               selectedMeetings ? selectedMeetings.has(row.meeting.id) : false
//             }
//             onSelectChange={handleSelectMeeting}
//             showCheckbox={true}
//             transScriptSession={transScriptSession}
//           />
//           {/* </Box> */}
//         </Collapse>
//       </div>
//     );
//   };

//   const handleDateChange = e => {
//     setDateValue(e);
//     fetchMeetingHistory(e);
//   };
  // const getItemSize = index => {
  //   const row = virtualRows[index];
  //   //return row.type === "header" ? 40 : 60; // adjust heights as needed
  //   const currentWidth = window.innerWidth;

  //   if (row.type === 'header') {
  //     return 40;
  //   } else {
  //     if (currentWidth < 600) {
  //       return 140;
  //     } else if (currentWidth < 960) {
  //       return 80;
  //     } else {
  //       return 60;
  //     }
  //   }
  // };

//   // Auto-open PiP when user navigates to this page
//   // useEffect(() => {
//   //   if (isPiPSupported && !isPiPOpen) {
//   //     // Small delay to ensure the page has loaded
//   //     const timer = setTimeout(() => {
//   //       openPiP({ width: 400, height: 500 });
//   //     }, 500);

//   //     return () => clearTimeout(timer);
//   //   }
//   // }, [location.pathname, isPiPSupported, isPiPOpen, openPiP]);



//   const isMobileView = isMobile || isTablet;

//   return (
//     <Box
//       sx={{
//         // p: {xs: 2, md: 3},
//         // backgroundColor: '#f0f4ff', // Main light blue background
//         // borderRadius: 4,
//         // boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
//         // border: '1px solid #e0e7ff',
//         // maxWidth: 1200,
//         // margin: 'auto',
//         width: '100%',
//         height: {
//           xs: ['calc(100vh - 201px)', 'calc(100dvh - 201px)'],
//           sm: ['calc(100vh - 145px)', 'calc(100dvh - 145px)'],
//         },
//         overflow: 'hidden',
//       }}
//     >
//       {/* for the desktop view */}
    
//         <Stack height={'100%'}>
//           {/* Top Bar: Search and Actions */}
//           <Box
//             sx={{
//               position: 'sticky',
//               top: 0,
//               zIndex: 12,
//               backgroundColor: 'var(--grey-0)',
//               borderBottom: '1px solid var(--grey-100)',
//             }}
//           >
//             <Box
//               display={'flex'}
//               alignItems={'center'}
//               gap={2}
//               sx={{
//                 m: 3,
//                 mb: 2,
//                 px: 2,
//                 py: 0.5,
//                 background: 'var(--grey-0)',
//                 border: '1px solid var(--grey-100)',
//                 borderRadius: '10px',
//               }}
//             >
//               <TextField
//                 fullWidth
//                 variant="standard"
//                 placeholder="Search meetings title here..."
//                 onChange={e => {
//                   const value = e.target.value.trim() || '';
//                   if (value && value.length > 0) {
//                     handleSearch(value);
//                   } else {
//                     setMeetingHistoryData({
//                       apiData: meetingHistoryData.apiData,
//                     });
//                   }
//                 }}
//                 slotProps={{
//                   input: {
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <SearchIcon color="action" />
//                       </InputAdornment>
//                     ),
//                   },
//                 }}
//                 type="search"
//                 size="small"
//                 sx={{
//                   '& .MuiInputBase-input': {
//                     padding: 0,
//                   },
//                   '& .MuiInput-underline:before': {
//                     borderBottom: 'none',
//                   },
//                   '& .MuiInput-underline:after': {
//                     borderBottom: 'none',
//                   },
//                   '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
//                     borderBottom: 'none',
//                   },
//                 }}
//               />
//               <Box display={'flex'} alignItems={'center'} gap={1}>
//                 <Tooltip title="Show Transcript Only" arrow>
//                   <Switch
//                     checked={transcriptOnlyToggle}
//                     onChange={e => {
//                       setTranscriptOnlyToggle(e.target.checked);
//                     }}
//                     size="small"
//                   />
//                 </Tooltip>
//                 <Tooltip title="Refresh" arrow>
//                   <IconButton size="small">
//                     <RefreshIcon
//                       onClick={() => {
//                         setTriggerMeetingHistoryCall(true);
//                       }}
//                     />
//                   </IconButton>
//                 </Tooltip>
//                 {/* <IconButton size="small"> */}
//                 <CustomDateRangePicker
//                   value={dateValue}
//                   setDateRangeValue={handleDateChange}
//                 />
//                 {/* </IconButton> */}
//               </Box>
//             </Box>
//             {Object.keys(ongoingMeeting).length > 0 &&
//               ongoingMeeting.isRecording && (
//                 <Stack
//                   key={'Recording Now'}
//                   spacing={0}
//                   className={'recording-now-box'}
//                   sx={{
//                     '&.recording-now-box': {
//                       position: 'sticky',
//                       top: '0',
//                       zIndex: '11',
//                       '.MuiPaper-root': {
//                         backgroundColor: 'var(--grey-100)',
//                       },
//                     },
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 0.5,
//                       px: 2,
//                       py: 1.5,
//                       borderTop: '1px solid var(--grey-100)',
//                       borderBottom: '1px solid var(--grey-100)',
//                       background: 'var(--grey-50)',
//                     }}
//                   >
//                     <BlinkingDot />
//                     <Typography
//                       variant="caption"
//                       fontWeight={500}
//                       color="primary.300"
//                     >
//                       Recording Now
//                     </Typography>
//                   </Box>
//                   <MeetingItem
//                     meeting={ongoingMeeting}
//                     handleSoftDelete={handleSoftDelete}
//                     isRecord={true}
//                     props={props}
//                     hasOngoingMeeting={true}
//                     dispatch={dispatch}
//                     meetingHistoryData={meetingHistoryData}
//                     transScriptSession={transScriptSession}
//                   />
//                 </Stack>
//               )}
//             {/* Select All and Bulk Actions */}
//             {getAllMeetings.length > 0 && (
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 1,
//                   px: 2,
//                   py: 1,
//                   borderBottom: '1px solid var(--grey-100)',
//                   backgroundColor: 'var(--grey-0)',
//                 }}
//               >
//                 <Checkbox
//                   checked={allMeetingsSelected}
//                   indeterminate={someMeetingsSelected}
//                   onChange={e => {
//                     handleSelectAll(getAllMeetings, e.target.checked);
//                   }}
//                   size="small"
//                 />
//                 <Typography variant="body2" color="text.primary">
//                   Select All ({selectedMeetings.size})
//                 </Typography>
//                 {selectedMeetings.size > 0 && (
//                   <>
//                     <Box sx={{ ml: 'auto', display: 'flex', gap: 0.5 }}>
//                       <Tooltip title="Delete Selected" arrow>
//                         <IconButton
//                           size="small"
//                           onClick={() => {
//                             setOpenBulkDeleteDialog(true);
//                           }}
//                           sx={{ color: 'error.main' }}
//                         >
//                           <DeleteOutlineIcon />
//                         </IconButton>
//                       </Tooltip>
//                     </Box>
//                   </>
//                 )}
//               </Box>
//             )}
//           </Box>

//           {/* Meetings List by Date */}
//           {dataExists ? (
//             <Box
//               sx={{
//                 height: '100%',
//                 overflowY: 'auto',
//               }}
//             >
//               <Stack sx={{ height: '100%', flex: '1 1 auto' }}>
//                 <List
//                   ref={listRef}
//                   height={window.innerHeight - 64} // Adjust based on sticky top bar
//                   itemCount={virtualRows.length}
//                   itemSize={getItemSize}
//                   width="100%"
//                   itemData={{
//                     data: virtualRows,
//                     isOngoing:
//                       Object.keys(ongoingMeeting).length > 0 &&
//                       ongoingMeeting.isRecording,
//                     selectedMeetings,
//                     handleSelectMeeting,
//                     handleSelectAll,
//                   }}
//                 >
//                   {Row}
//                 </List>
//               </Stack>
//             </Box>
//           ) : (
//             <Box
//               sx={{
//                 justifyContent: 'center',
//                 alignContent: 'center',
//                 alignItems: 'center',
//                 height: '100%',
//                 display: 'flex',
//                 width: '100%',
//               }}
//             >
//               <Typography vertical="body2" color={'text.primary'}>
//                 <b>No Records Found</b>
//               </Typography>
//             </Box>
//           )}

//           {/* <Stack sx={{ height: '100%', overflow: 'auto', flex: '1 1 auto' }}>
//           {groupedMeetingData.map(({ dateLabel, meetings }) => (
//             <Stack
//               key={dateLabel}
//               spacing={0}
//               className={undefined}
//               sx={{
//                 "&.recording-now-box": {
//                   position: "sticky",
//                   top: "0",
//                   zIndex: "11",
//                   ".MuiPaper-root": {
//                     backgroundColor: 'var(--grey-100)',
//                   }
//                 }
//               }}
//             >
//               <Box
//                 sx={{
//                   px: 2,
//                   py: 1.5,
//                   borderTop: '1px solid var(--grey-100)',
//                   borderBottom: '1px solid var(--grey-100)',
//                   background: 'var(--grey-50)',
//                   position: "sticky",
//                   top: 0,
//                   zIndex: "1"
//                 }}
//               >
//                 <Typography variant="caption" color="text.primary">
//                   {dateLabel}
//                 </Typography>
//               </Box>
//               <Stack>
//                 {meetings.map((meeting) => (
//                   <MeetingItem key={meeting.id} meeting={meeting} handleSoftDelete={handleSoftDelete} />
//                 ))}
//               </Stack>
//             </Stack>
//           ))}
//         </Stack> */}
//         </Stack>

//       {/* Bulk Delete Confirmation Dialog */}
//       <Dialog
//         open={openBulkDeleteDialog}
//         onClose={() => setOpenBulkDeleteDialog(false)}
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle>
//           <Typography
//             variant="subtitle1"
//             component={'span'}
//             color="text.primary"
//           >
//             Are you sure you want to continue?
//           </Typography>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="text.primary">
//             {selectedMeetings.size === 1 ? (
//               <>1 meeting will be deleted.</>
//             ) : (
//               <>{selectedMeetings.size} meetings will be deleted.</>
//             )}
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() => {
//               setOpenBulkDeleteDialog(false);
//             }}
//           >
//             Cancel
//           </Button>
//           <Button color="error" variant="contained" onClick={handleBulkDelete}>
//             DELETE
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }



import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import {
  Box,
  Paper,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
  Stack,
  Button,
  Divider,
  Chip,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Collapse,
  Popover,
  ButtonBase,
  Switch,
  Checkbox,
  Grid,
  SwipeableDrawer,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import { ROUTES, isTranscriptRoute } from '../../routes';
import { styled, keyframes } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// --- ICONS ---
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EjectOutlinedIcon from '@mui/icons-material/EjectOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import LinkIcon from '@mui/icons-material/Link';
import NotStartedOutlinedIcon from '@mui/icons-material/NotStartedOutlined';
import copy from 'copy-to-clipboard';
import { GMailIcon, WhatsAppIcon } from '../../components/SvgIcon/SvgIcon';
import {
  WhatsappShareButton,
  TelegramShareButton,
  FacebookShareButton,
  LinkedinShareButton,
} from 'react-share';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { API_URL } from '../../config/apiUrl';
import { VariableSizeList as List } from 'react-window';
import CustomDateRangePicker from '../../common/datePicker/Daterangepicker';
import dayjs from 'dayjs';
import StartTime from '@mui/icons-material/AccessTime';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import PhotoIcon from '@mui/icons-material/PhotoFilter';
// import { useDocumentPiP } from "../../hooks/useDocumentPiP";
import { openSnackbar } from '../../redux/actions/snackbarAction';
import { setCurrentRecording, resetRecording } from '../../redux/actions/currentRecording';
import { useTranscriber } from '../../hooks/useTranscriber';
import { isMobile, isTablet } from 'react-device-detect';
import {
  SwipeableList,
  SwipeableListItem,
  SwipeAction,
  TrailingActions,
  Type as ListType,
} from 'react-swipeable-list';
import 'react-swipeable-list/dist/styles.css';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import norecordsfound from '../../assets/images/norecordsfound.png';

const MIN_ROW_WIDTH = 932;
// --- DATA PROCESSING UTILITY ---
// Groups meetings by dateLabel and ensures "Recording Now" is first
const groupMeetings = data => {
  const groups = data.reduce((acc, meeting) => {
    const key = meeting.dateLabel;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(meeting);
    return acc;
  }, {});

  const sortedKeys = Object.keys(groups).sort((a, b) => {
    const getDate = str => {
      const label = str.split(', ')[0];
      const datePart = str.split(', ')[1];
      const [day, month, year] = datePart.split('/').map(Number);
      return {
        label,
        date: new Date(2000 + year, month - 1, day),
      };
    };

    const aData = getDate(a);
    const bData = getDate(b);

    // Priority: Today (1), Yesterday (2), Others (3)
    const getPriority = label => {
      if (label === 'Today') return 1;
      if (label === 'Yesterday') return 2;
      return 3;
    };

    const aPriority = getPriority(aData.label);
    const bPriority = getPriority(bData.label);

    if (aPriority !== bPriority) return aPriority - bPriority;
    // return aData.date - bData.date;
    return bData.date - aData.date;
  });

  return sortedKeys.map(key => ({
    dateLabel: key,
    meetings: groups[key],
  }));
};

// --- STYLED COMPONENTS ---
// Blinking animation for the "Recording Now" indicator
const blinkAnimation = keyframes`
  50% {
    opacity: 0;
  }
`;

const BlinkingDot = styled('div')(({ theme }) => ({
  height: 5,
  width: 5,
  borderRadius: '50%',
  backgroundColor: 'var(--primary-300)',
  animation: `${blinkAnimation} 1.5s linear infinite`,
}));

// --- CHILD COMPONENT: MeetingItem ---
const MeetingItem = React.memo(({
  meeting,
  handleSoftDelete,
  props,
  setLoading,
  setDetails,
  setMeetingAPIDetails,
  navigate,
  isRecord,
  hasOngoingMeeting,
  dispatch,
  meetingHistoryData,
  resetAll,
  isSelected,
  onSelectChange,
  showCheckbox = false,
   swipedItemId, 
  setSwipedItemId,
  transScriptSession,
  onLongPress,
  setTriggerMeetingHistoryCall,
}) => {
    const isMobileView = isMobile || isTablet;
    
    // Long-press handler state
    const longPressTimerRef = useRef(null);
    const touchStartTimeRef = useRef(null);
    
    // Cleanup on unmount
    useEffect(() => {
      return () => {
        if (longPressTimerRef.current) {
          clearTimeout(longPressTimerRef.current);
        }
      };
    }, []);
    
    // Handler for Resume button
    const handleResumeClick = (event) => {
      event?.stopPropagation?.();
      // Allow resume even if there's an ongoing meeting - resetAll() will handle stopping it
      meetingDetailsRef.current = {
        meetingDetails: meeting,
        isResume: true,
        isDetailsView: false,
      };
      setDialogOpen(true);
    };

    // Handler for Share button
    const handleShareButtonClick = (event) => {
      event?.stopPropagation?.();
      // Create a synthetic event if none is provided (SwipeAction might not pass event)
      const syntheticEvent = event || { stopPropagation: () => {} };
      handleShareClick(syntheticEvent);
    };

    // Handler for Delete button
    const handleDeleteClick = (event) => {
      event?.stopPropagation?.();
      setOpenDeleteDialogue(true);
    };

     const trailingActions = (
    <TrailingActions>
      <SwipeAction
        destructive={true}
        onClick={handleResumeClick}
      >
        <Box
          sx={{
            width: '80px',
            height: '100%',
            bgcolor: 'grey.500',
            color: 'white',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          <NotStartedOutlinedIcon sx={{ fontSize: 24, mb: 0.5 }} />
          <Typography variant="caption" fontWeight={700}>Resume</Typography>
        </Box>
      </SwipeAction>
      <SwipeAction
        destructive={true}
        onClick={handleShareButtonClick}
      >
        <Box
          sx={{
            width: '80px',
            height: '100%',
            bgcolor: 'success.main',
            color: 'white',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          <ShareOutlinedIcon sx={{ fontSize: 24, mb: 0.5 }} />
          <Typography variant="caption" fontWeight={700}>Share</Typography>
        </Box>
      </SwipeAction>
      <SwipeAction
        destructive={true}
        onClick={handleDeleteClick}
      >
        <Box
          sx={{
            width: '80px',
            height: '100%',
            bgcolor: 'error.main',
            color: 'white',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          <DeleteOutlineIcon sx={{ fontSize: 24, mb: 0.5 }} />
          <Typography variant="caption" fontWeight={700}>Delete</Typography>
        </Box>
      </SwipeAction>
    </TrailingActions>
    
  );
  const swipeKey = swipedItemId === meeting.id ? 'open' : 'reset';
  const [dialogOpen, setDialogOpen] = useState(false);
  const [hoverDisplay, setHoverDisplay] = useState(false);
  const [openDeleteDialogue, setOpenDeleteDialogue] = useState(false);
  const [shareUrl, setShareUrl] = useState('');
  const [isLoadingShare, setIsLoadingShare] = useState(false);
  const [openShareDialog, setOpenShareDialog] = useState(false);
  const [copied, setCopied] = useState(false);
  const meetingDetailsRef = useRef({});

  const handleShareClick = async event => {
    event?.stopPropagation?.();
    setIsLoadingShare(true);
    setOpenShareDialog(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/share`,
        {
          recording_id: meeting.id,
        },
        {
          headers: {
            Authorization: `Bearer ${transScriptSession}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data && response.data.url) {
        setShareUrl(response.data.url);
      } else {
        dispatch(openSnackbar('error', 'Failed to generate share URL.'));
        setOpenShareDialog(false);
      }
    } catch (error) {
      // Error sharing meeting
      dispatch(
        openSnackbar(
          'error',
          error.response?.data?.message ||
            'Something went wrong while sharing meeting.'
        )
      );
      setOpenShareDialog(false);
    } finally {
      setIsLoadingShare(false);
    }
  };

  const handleShareDialogClose = () => {
    setOpenShareDialog(false);
    setShareUrl('');
    setCopied(false);
  };

  const handleCopyUrl = () => {
    if (shareUrl) {
      const copySuccess = copy(shareUrl);
      if (copySuccess) {
        setCopied(true);
        dispatch(openSnackbar('success', 'URL copied to clipboard!'));
        setTimeout(() => setCopied(false), 2000);
      } else {
        dispatch(openSnackbar('error', 'Failed to copy URL.'));
      }
    }
  };

  const [popoverAnchor, setPopoverAnchor] = useState(null);
  const [childMeetingDetails, setChildMeetingDetails] = useState({});

  const handlePopoverOpen = (event, meetingDetails) => {
    // event.stopPropagation();
    setChildMeetingDetails(meetingDetails);
    setPopoverAnchor(event.currentTarget);
  };

  const handlePopoverClose = event => {
    event.stopPropagation();
    setChildMeetingDetails({});
    setPopoverAnchor(null);
  };
  const open = Boolean(popoverAnchor);

  const subject = encodeURIComponent('Check this out!');
  const body = encodeURIComponent(`Hey, take a look at this:\n\n${shareUrl}`);
  const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&su=${subject}&body=${body}`;
  const credits = useSelector(state => state.user.credits);
  const isResumeDisabled = credits <= 0;
  const ClickableWrapper = ({ children }) => {

    
    const commonStyles = {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      textAlign: 'left',
      minWidth: 0, // Critical for text truncation in flex
    };
    return isRecord ? (
      // For ongoing meetings: make clickable in desktop view to navigate to home
      !isMobileView ? (
        <ButtonBase
          onClick={() => {
            navigate(ROUTES.HOME);
          }}
          sx={{
            ...commonStyles,
            cursor: 'pointer',
          }}
        >
          {children}
        </ButtonBase>
      ) : (
        // For mobile view: parent Box handles click, so just render Box here
        <Box sx={commonStyles}>{children}</Box>
      )
    ) : (
    <ButtonBase
        onClick={() => {
          setLoading(true);
          setDetails({
            meetingDetails: meeting,
            isResume: false,
            isDetailsView: true,
          });
          navigate(ROUTES.MEETING(meeting.id));
        }}
        sx={commonStyles}
      >
        {children}
      </ButtonBase>
    );
  };

  const parentDetialsDisplay = () => {
    var parentDetails = {};
    if (childMeetingDetails.hasInfo) {
      var details = meetingHistoryData.apiData.find(
        data => data.id === childMeetingDetails.parentRecordingId
      );
      if (details && Object.keys(details).length > 0) {
        parentDetails = { ...details };
      } else {
        setChildMeetingDetails({});
        setPopoverAnchor(null);
        dispatch(
          openSnackbar(
            'warning',
            'Parent meeting details not found. Either meeting was deleted or not found in the selected date range.'
          )
        );
        return;
      }
    }

    return (
      <Popover
        open={Boolean(popoverAnchor)}
        anchorEl={popoverAnchor}
        onClose={handlePopoverClose}
        onClick={e => {
          e.stopPropagation();
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        disableRestoreFocus
        slotProps={{
          paper: {
            sx: {
              width: 210,
            },
          },
        }}
      >
        {parentDetails && Object.keys(parentDetails).length > 0 && (
          <Box py={1} px={1.5}>
            <Box>
              <Typography variant="caption" color="grey.400">
                Meeting Title
              </Typography>
              <Tooltip title={parentDetails.title} arrow>
                <Typography
                  variant="body2"
                  component="div"
                  noWrap
                  fontWeight={500}
                  color="secondary.main"
                >
                  {parentDetails.title}
                </Typography>
              </Tooltip>
            </Box>

            <Box display={'flex'} alignItems={'center'} gap={2}>
              <Box>
                <Typography variant="caption" color="grey.400">
                  Duration
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight={500}
                  color="text.primary"
                >
                  {parentDetails.duration}
                </Typography>
              </Box>

              <Box>
                <Typography variant="caption" color="grey.400">
                  Start Time
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight={500}
                  color="text.primary"
                >
                  {parentDetails.startTime}
                </Typography>
              </Box>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary">
                Date
              </Typography>
              <Typography variant="body2" fontWeight={500} color="text.primary">
                {parentDetails.dateLabel}
              </Typography>
            </Box>
          </Box>
        )}
      </Popover>
    );
  };

  // Reusable Info button to avoid repeating logic across breakpoints
  const InfoButton = ({ sx: sxProp }) => {
    if (!meeting.hasInfo) return null;

    return (
      <Box
        onClick={e => e.stopPropagation()}
        sx={{ alignSelf: 'flex-end', marginBottom: '-4px', ...(sxProp || {}) }}
      >
        <Tooltip title="Parent Meeting Details" arrow>
          <IconButton
            size="small"
            onClick={e => {
              handlePopoverOpen(e, meeting);
            }}
          >
            <InfoOutlinedIcon color="primary" fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };

  return (
    <>
      {!isMobileView && (
      <Paper
        // variant="outlined"
        sx={{
          // py: 1,
          // px: 2,
          backgroundColor: 'var(--grey-0)',
          // borderColor: '#e8eef6',
          borderRadius: 0,
          // borderBottom: "1px solid var(--grey-100)",
          padding:'0px',
        }}
        elevation={0}
      >
        <Stack
          direction="row"
          alignItems="center"
          // sx={{
          //   width: '100%',
          //   display: 'flex',
          //   alignItems: 'center',
          //   textAlign: 'left',
          //   // px: 2,
          //   // py: 1,
          //   // borderRadius: 1,
          //   justifyContent: 'start',
          //   // "&:hover": {
          //   //   backgroundColor: "var(--grey-50)",
          //   // },
          //   flexWrap: { xs: 'wrap', sm: 'nowrap' },
          //   gap: { xs: 0.5, sm: 0 },
          // }}
          sx={{
            width: '100%',
            minWidth: `${MIN_ROW_WIDTH}px`, // This forces the horizontal scroll
            height: '60px',
            gap: 0,
            display: 'flex',
            alignItems: 'center',
            textAlign: 'left',
            justifyContent: 'start',
            flexWrap: 'nowrap',
            gap: { xs: 0.5, sm: 0 },
            borderBottom: '1px solid var(--grey-100)',
            padding:'0px 0px 0px 16px'
          }}
        >
          {showCheckbox && !isRecord && (
            <Checkbox
              checked={isSelected || false}
              onChange={e => {
                e.stopPropagation();
                onSelectChange && onSelectChange(meeting.id, e.target.checked);
              }}
              onClick={e => e.stopPropagation()}
              size="small"
              sx={{ mr: 1}}
            />
          )}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'end',
              gap: 0.5,
              width: { xs: '92%', sm: '296px', md: '303px' },
              marginRight: { xs: 'auto', md: 0 },
            }}
          >
            <ClickableWrapper>
              {/* Meeting Title */}

                <Typography
                  variant="caption"
                  color="grey.400"
                  sx={{ display: 'block' }}
                >
                  Meeting Title
                </Typography>

                <Tooltip title={meeting.title} arrow>
                  <Typography
                    variant="body2"
                    component="div"
                    noWrap
                    fontWeight={500}
                    color="secondary.main"
                    width={'100%'}
                  >
                    {meeting.title}
                  </Typography>
                </Tooltip>
              </ClickableWrapper>
            {/* </Box> */}
            {meeting.hasInfo && (
              <Box
                onClick={e => e.stopPropagation()}
                sx={{ alignSelf: 'flex-end', marginBottom: '-4px' }}
              >
                <Tooltip title="Parent Meeting Details" arrow>
                  <IconButton
                    size="small"
                    onClick={e => {
                      handlePopoverOpen(e, meeting);
                    }}
                  >
                    <InfoOutlinedIcon color="primary" fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            {Boolean(popoverAnchor) && <>{parentDetialsDisplay()}</>}
            {/* Info Icon start  */}
          </Box>
          <Divider
            orientation="vertical"
            variant="middle"
            flexItem
            sx={{
              mx: 2,
              height: 28,
              alignSelf: 'center', 
              display: { xs: 'none', sm: 'block' },
            }}
          />

          {/* Start Time */}
         <Box sx={{ flexShrink: 0, ml: { xs: 'auto', sm: '0' } }}>
            <Typography variant="caption" color="grey.400">
              Start Time
            </Typography>
            <Typography variant="body2" fontWeight={500} color="text.primary">
              {meeting.startTime}
            </Typography>
          </Box>
          <Divider
            orientation="vertical"
            variant="middle"
            flexItem
            sx={{
              mx: 2,
              height: 28,
               alignSelf: 'center', 
              display: { xs: 'none', sm: 'block' },
            }}
          />
          {/* Duration */}
          <Box sx={{ flexShrink: 0 }}>
            <Typography variant="caption" color="grey.400">
              Duration
            </Typography>
            <Typography variant="body2" fontWeight={500} color="text.primary">
              {meeting.duration}
            </Typography>
          </Box>
          {!meeting.isRecording && (
            <>
              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={{
                  mx: 2,
                  height: 28,
                  alignSelf: 'center', 
                  display: { xs: 'none', sm: 'block' },
                }}
              />
              <Box sx={{ flexShrink: 0, ml: { xs: 'auto', sm: '0' } }}>
                <Typography variant="caption" color="grey.400">
                  Credits Used
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight={500}
                  color="text.primary"
                >
                  {meeting.creditsUsed}
                </Typography>
              </Box>
            </>
          )}

          {/* Actions */}
           <Box sx={{
             width: 'auto', 
             minWidth: '231px', 
             flexShrink: 0, 
             display: 'flex', 
             justifyContent: 'flex-end',
             alignItems: 'center', 
             gap: 0.5, 
             marginLeft: 'auto', 
             paddingRight: '16px', // Add slight padding from edge
           }}>
          {/* <Box sx={{
            width: '180px',
            flexShrink: 0, display:'flex', justifyContent: 'flex-end',
            alignItems: 'center', gap: 0.5, ml: 2
          }}> */}
            {meeting.status === 'transcript' && (
              <Chip
                variant="outlined"
                size="small"
                label="Transcript Only"
                color="primary"
                sx={{
                  marginRight: { xs: 'auto', md: 0 },
                }}
              />
            )}
            {!meeting.isRecording && (
              <>
                <Tooltip title="Resume" arrow>
                  <IconButton
                    size="small"
                    disabled={isResumeDisabled}
                    onClick={() => {
                      if (!hasOngoingMeeting) {
                        meetingDetailsRef.current = {
                          meetingDetails: meeting,
                          isResume: true,
                          isDetailsView: false,
                        };
                        setDialogOpen(true);
                      } else {
                        dispatch(
                          openSnackbar(
                            'warning',
                            'Please end the ongoing meeting first to create a new meeting.'
                          )
                        );
                      }
                    }}
                  >
                    <EjectOutlinedIcon
                      sx={{
                        transform: 'rotate(90deg)',
                        color: isResumeDisabled
                          ? 'text.disabled'
                          : 'text.primary',
                      }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Share" arrow>
                  <IconButton
                    size="small"
                    onClick={handleShareClick}
                    disabled={isLoadingShare}
                  >
                    <ShareOutlinedIcon
                      fontSize="small"
                      sx={{ color: 'text.primary' }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete" arrow>
                  <IconButton
                    size="small"
                    onMouseEnter={() => {
                      setHoverDisplay(true);
                    }}
                    onMouseLeave={() => {
                      setHoverDisplay(false);
                    }}
                    onClick={() => {
                      setOpenDeleteDialogue(true);
                    }}
                  >
                    <DeleteOutlineIcon
                      fontSize="small"
                      sx={{ color: 'error.main' }}
                    />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </Box>
        </Stack>
      </Paper>
      )}
       {isMobileView && (
        <Box sx={{ width: '100%', height: '100%', backgroundColor: 'white' }}>
          <SwipeableList threshold={0.5} type={ListType.IOS}>
            <SwipeableListItem
              trailingActions={trailingActions}
              onSwipeStart={() => {
                if (setSwipedItemId && swipedItemId !== meeting.id) {
                  setSwipedItemId(meeting.id);
                }
              }}
              key={`${meeting.id}-${swipeKey}`}
            >
              {/* Main Card Content */}
              <Box
                padding={'8px 18px'}
                onClick={isRecord && isMobileView ? () => navigate(ROUTES.HOME) : undefined}
                onTouchStart={(e) => {
                  if (!isMobileView || isRecord || !onLongPress) return;
                  touchStartTimeRef.current = Date.now();
                  longPressTimerRef.current = setTimeout(() => {
                    onLongPress(meeting.id, e);
                  }, 500); // 500ms for long-press
                }}
                onTouchEnd={(e) => {
                  if (longPressTimerRef.current) {
                    clearTimeout(longPressTimerRef.current);
                    longPressTimerRef.current = null;
                  }
                }}
                onTouchMove={(e) => {
                  // Cancel long-press if user moves finger
                  if (longPressTimerRef.current) {
                    clearTimeout(longPressTimerRef.current);
                    longPressTimerRef.current = null;
                  }
                }}
                sx={{
                  width: '100%',
                  display: 'flex',
                  borderBottom: '1px solid var(--grey-100)',
                  alignItems: 'flex-start',
                  backgroundColor: 'white',
                  height: meeting.status === 'transcript' ? '95px' : '65px',
                  cursor: isRecord && isMobileView ? 'pointer' : 'default',
                }}

              >
                {/* Checkbox */}
                {showCheckbox && !isRecord && (
                  <Checkbox
                    checked={isSelected || false}
                    onChange={e => {
                      e.stopPropagation();
                      onSelectChange && onSelectChange(meeting.id, e.target.checked);
                    }}
                    onClick={e => e.stopPropagation()}
                    size="small"
                    sx={{ mr: 1, padding:'0px 0px'}}
                  />
                )}

                {/* Text Content */}
                {/* <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 0.5,
                width: { xs: '92%'}
                }}> */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 0.5, minWidth: 0, justifyContent: 'center' }}>
                  
                   <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <ClickableWrapper>
                      <Typography
                        variant="body2"
                        component="div"
                        noWrap
                        fontWeight={500}
                        color="secondary.main"
                        width={'100%'}
                      >
                        {meeting.title}
                      </Typography>
                    </ClickableWrapper>

                    {/* Mobile Parent Info */}
                    {meeting.hasInfo && (
                      <Box
                        onClick={e => e.stopPropagation()}
                        sx={{ alignSelf: 'flex-end', marginBottom: '-4px' }}
                      >
                        <Tooltip title="Parent Meeting Details" arrow>
                          <IconButton
                            size="small"
                            onClick={e => {
                              handlePopoverOpen(e, meeting);
                              
                            }}
                                sx={{ marginBottom: '4px',padding:'0px' }}
                          >
                            <InfoOutlinedIcon color="primary" fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    )}
                    {Boolean(popoverAnchor) && <>{parentDetialsDisplay()}</>}
                  </Box>
                  <Box sx={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center', gap: 1 }}>
                    {/* Start time */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Tooltip title="Start Time" arrow>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <StartTime fontSize="small" sx={{ color: 'grey.400' }} />
                          <Typography variant="body2" fontWeight={500} color="text.primary" noWrap>
                            {meeting.startTime}
                          </Typography>
                        </Box>
                      </Tooltip>
                    </Box>

                    {/* Duration */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Tooltip title="Duration" arrow>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <TimerOutlinedIcon fontSize="small" sx={{ color: 'grey.400' }} />
                          <Typography variant="body2" fontWeight={500} color="text.primary" noWrap>
                            {meeting.duration}
                          </Typography>
                        </Box>
                      </Tooltip>
                    </Box>

                    {/* Credits used (hide when recording) */}
                    {!meeting.isRecording && (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Tooltip title="Credit Used" arrow>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <PhotoIcon fontSize="small" sx={{ color: 'grey.400' }} />
                            <Typography variant="body2" fontWeight={500} color="text.primary" noWrap>
                              {meeting.creditsUsed}
                            </Typography>
                          </Box>
                        </Tooltip>
                      </Box>
                    )}
                  </Box>

                  {/* Mobile Actions Row */}
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                    {meeting.status === 'transcript' && (
                      <Chip
                        variant="outlined"
                        size="small"
                        label="Transcript Only"
                        color="primary"
                        sx={{
                          marginRight: { xs: 'auto', md: 0 },
                        }}
                      />
                    )}



                    
                    {/* for the share and resume the meeting content code is below */}
                    {/*                   
                      {!meeting.isRecording && (
                        <>
                          <Tooltip title="Resume" arrow>
                            <IconButton
                              size="small"
                              disabled={isResumeDisabled}
                              onClick={() => {
                                if (!hasOngoingMeeting) {
                                  meetingDetailsRef.current = {
                                    meetingDetails: meeting,
                                    isResume: true,
                                    isDetailsView: false,
                                  };
                                  setDialogOpen(true);
                                } else {
                                  dispatch(
                                    openSnackbar(
                                      'warning',
                                      'Please end the ongoing meeting first to create a new meeting.'
                                    )
                                  );
                                }
                              }}
                            >
                              <EjectOutlinedIcon
                                sx={{
                                  transform: 'rotate(90deg)',
                                  color: isResumeDisabled
                                    ? 'text.disabled'
                                    : 'text.primary',
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Share" arrow>
                            <IconButton
                              size="small"
                              onClick={handleShareClick}
                              disabled={isLoadingShare}
                            >
                              <ShareOutlinedIcon
                                fontSize="small"
                                sx={{ color: 'text.primary' }}
                              />
                            </IconButton>
                          </Tooltip>
                        <SwipeableDrawer
                          anchor="bottom"
                          open={openShareDialog}
                          onClose={handleShareDialogClose}
                          onOpen={() => { }}
                          disableSwipeToOpen={true}
                          PaperProps={{
                            sx: {
                              borderTopLeftRadius: '24px', 
                              borderTopRightRadius: '24px',
                              paddingBottom: '24px', 
                              maxHeight: '90vh', 
                            },
                          }}
                        >

                          <Box
                            sx={{
                              width: 40,
                              height: 6,
                              backgroundColor: 'grey.300',
                              borderRadius: 3,
                              position: 'absolute',
                              top: 8,
                              left: 'calc(50% - 20px)',
                            }}
                          />

                          <Box sx={{ padding: '24px 24px 16px 24px' }}>
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                              <Box display="flex" alignItems="center" gap={1}>
                                <LinkIcon sx={{ color: 'primary.main' }} />
                                <Typography variant="h6" component="span" fontWeight={600}>
                                  Share link
                                </Typography>
                              </Box>
                              <IconButton
                                aria-label="close"
                                onClick={handleShareDialogClose}
                                size="small"
                                sx={{ color: 'text.secondary' }}
                              >
                                <CloseIcon />
                              </IconButton>
                            </Box>
                          </Box>

                          <Box sx={{ padding: '0px 24px' }}>
                          {isLoadingShare && !shareUrl ? (
                                <Box display="flex" justifyContent="center" flexWrap={'wrap'} py={4}>
                                  <Typography variant="body2" color="text.secondary">
                                    Loading share URL...
                                  </Typography>
                                </Box>
                              ) : shareUrl ? (
                                <Stack spacing={3}>
                                  <Box>
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                      fontWeight={500}
                                      sx={{ mb: 1, display: 'block' }}
                                    >
                                      URL
                                    </Typography>
                                    <Box display="flex" gap={1} flexWrap={'nowrap'}>
                                      <TextField
                                        id="share-url-2"
                                        name="shareUrl"
                                        fullWidth
                                        value={shareUrl}
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                          readOnly: true,
                                          sx: {
                                            backgroundColor: 'var(--grey-50)',
                                            fontSize: '14px',
                                          },
                                        }}
                                      />
                                      <Tooltip title={copied ? "Copied!" : "Copy link"}>
                                        <IconButton
                                        size='small'
                                          onClick={handleCopyUrl}
                                          color="primary"
                                          sx={{
                                            border: '1px solid',
                                            borderColor: 'bluegrey.500',
                                            borderRadius: 1, 
                                          
                                          }}
                                        >
                                          <ContentCopyIcon />
                                        </IconButton>
                                      </Tooltip>
                                  </Box>
                                </Box>
                                <Box>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    fontWeight={500}
                                    sx={{ mb: 2, display: 'block' }}
                                  >
                                    Share using
                                  </Typography>
                                  <Grid container spacing={2} sx={{ alignItems: 'stretch' }}>
                                      <Grid item xs={4} sm={3}>
                                        <WhatsappShareButton
                                          url={shareUrl}
                                          style={{
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 8,
                                            padding: '12px',
                                            border: '1px solid var(--grey-100)',
                                            borderRadius: '8px',
                                            backgroundColor: 'transparent',
                                            cursor: 'pointer',
                                            textDecoration: 'none',
                                            transition: 'all 0.2s',
                                          }}
                                          onMouseEnter={e => {
                                            e.currentTarget.style.backgroundColor =
                                              'var(--grey-50)';
                                          }}
                                          onMouseLeave={e => {
                                            e.currentTarget.style.backgroundColor =
                                              'transparent';
                                          }}
                                        >
                                          <WhatsAppIcon sx={{ fontSize: 28 }} />
                                          <Typography
                                            variant="caption"
                                            color="text.primary"
                                          >
                                            WhatsApp
                                          </Typography>
                                        </WhatsappShareButton>
                                      </Grid>
                                      <Grid item xs={4} sm={3}>
                                        <Box
                                          component="div"
                                          onClick={() => {
                                            window.location.href = gmailLink;
                                          }}
                                          sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 1,
                                            padding: '12px',
                                            border: '1px solid var(--grey-100)',
                                            borderRadius: '8px',
                                            backgroundColor: 'transparent',
                                            cursor: 'pointer',
                                            width:'90px',
                                            height:'86px',
                                            transition: 'all 0.2s',
                                            '&:hover': {
                                              backgroundColor: 'var(--grey-50)',
                                            },
                                          }}
                                        >
                                          <GMailIcon
                                            sx={{ fontSize: 28, color: '#EA4335' }}
                                          />
                                          <Typography
                                            variant="caption"
                                            color="text.primary"
                                          >
                                            Email
                                          </Typography>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                </Box>
                              </Stack>
                            ) : null}
                          </Box>
                        </SwipeableDrawer> */}

                          {/* <Tooltip title="Delete" arrow>
                            <IconButton
                              size="small"
                              onMouseEnter={() => {
                                setHoverDisplay(true);
                              }}
                              onMouseLeave={() => {
                                setHoverDisplay(false);
                              }}
                              onClick={() => {
                                setOpenDeleteDialogue(true);
                              }}
                            >
                              <DeleteOutlineIcon
                                fontSize="small"
                                sx={{ color: 'error.main' }}
                              />
                            </IconButton>
                          </Tooltip> */}
                        {/* </>
                      )}
                       */}

                      {/* Mobile Share (or trigger share dialog) */}
                      {/* <IconButton
                        size="small"
                        onClick={handleShareClick}
                        disabled={isLoadingShare}
                      >
                        <ShareOutlinedIcon fontSize="small" color="action" />
                      </IconButton> */}
                 
                  </Box>
                </Box>
              </Box>
            </SwipeableListItem>
          </SwipeableList>
        </Box>
      )}
      {/* Share Dialog - Available for both mobile and desktop */}
      <Dialog
        open={openShareDialog}
        onClose={handleShareDialogClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            width: 380,
            maxWidth: 'calc(100vw - 32px)',
          },
        }}
      >
        <DialogTitle>
          <Box display="flex" alignItems="center" gap={1}>
            <LinkIcon sx={{ color: 'primary.main' }} />
            <Typography
              variant="h6"
              component="span"
              fontWeight={600}
            >
              Share link
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleShareDialogClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'text.secondary',
              }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {isLoadingShare && !shareUrl ? (
            <Box display="flex" justifyContent="center" py={4}>
              <Typography variant="body2" color="text.secondary">
                Loading share URL...
              </Typography>
            </Box>
          ) : shareUrl ? (
            <Stack spacing={0}>
              {/* URL Section */}
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  fontWeight={500}
                  sx={{ mb: 1, display: 'block' }}
                >
                  URL
                </Typography>
                <Box display="flex" gap={1}>
                <TextField
                    fullWidth
                    value={shareUrl}
                    variant="outlined"
                    size="small"
                    sx={{ minWidth: 0 }}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        backgroundColor: 'var(--grey-50)',
                        fontSize: '14px',
                        borderRadius: 1.5,
                        '& fieldset': { borderRadius: 1.5 },
                      },
                    }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleCopyUrl}
                    startIcon={<ContentCopyIcon />}
                    sx={{
                      '& .MuiButton-startIcon': {
                        marginLeft: 0,
                        marginRight: 0,
                      },
                    }}
                  >
                    {/* {copied ? 'Copied!' : 'Copy link'} */}
                  </Button>
                </Box>
              </Box>

              {/* Share Using Section */}
             
              <Box
                    sx={{
                      flex: 1,
                      height: 1,
                      marginTop: '12px',
                     
                    }}
                  >
              <Typography
                    variant="caption"
                    sx={{
                      color: 'text.secondary',
                      fontWeight: 500,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      marginBottom: '12px',
                    }}
                  >
                    Share using
                  </Typography>
                <Grid container spacing={1.5} display="flex" flexWrap="nowrap" marginTop="8px" >
                  <Grid item xs={6} width={"100%"}>
                    <WhatsappShareButton
                      url={shareUrl}
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 6,
                        padding: '12px',
                        border: '1px solid var(--grey-100)',
                        borderRadius: '8px',
                        backgroundColor: 'transparent',
                        cursor: 'pointer',
                        textDecoration: 'none',
                        transition: 'all 0.2s',
                      }}
                      onMouseEnter={e => {
                        e.currentTarget.style.backgroundColor =
                          'var(--grey-50)';
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                      }}
                    >
                      <WhatsAppIcon sx={{ fontSize: 28 }} />
                      <Typography variant="body2" color="text.primary" fontWeight={500}>
                        WhatsApp
                      </Typography>
                    </WhatsappShareButton>
                  </Grid>
                  <Grid item xs={6} width={"100%"}>
                    <Box
                      component="div"
                      onClick={() => {
                        window.location.href = gmailLink;
                      }}
                      sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 0.5,
                        padding: '12px',
                        border: '1px solid var(--grey-100)',
                        borderRadius: '8px',
                        backgroundColor: 'transparent',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        '&:hover': {
                          backgroundColor: 'var(--grey-50)',
                        },
                      }}
                    >
                      <GMailIcon sx={{ fontSize: 28, color: '#EA4335' }} />
                      <Typography variant="body2" color="text.primary" fontWeight={500}>
                        Email
                      </Typography>
                    </Box>
                  </Grid>
                  
                  </Grid>
              </Box>
            </Stack>
          ) : null}
        </DialogContent>
      </Dialog>
      <Dialog
        open={openDeleteDialogue}
        onClose={() => setOpenDeleteDialogue(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography
            variant="subtitle1"
            component={'span'}
            color="text.primary"
          >
            Are you sure you want to continue?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.primary">
            {/* {`${meeting?.title} will be deleted.`} */}
            {
              <>
                <strong>{meeting?.title}</strong> will be deleted.
              </>
            }
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialogue(false)}>
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={() => {
              handleSoftDelete(meeting?.id);
              setOpenDeleteDialogue(false);
            }}
          >
            DELETE
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography
            variant="subtitle1"
            component={'span'}
            color="text.primary"
          >
            Are you sure you want to continue?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.primary">
            This will start a new meeting from where you left off.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={async () => {
              try {
                const permResult = await navigator.permissions.query({ name: 'microphone' });
                if (permResult.state === 'denied') {
                  setDialogOpen(false);
                  dispatch(
                    openSnackbar(
                      'error',
                      'Please allow Microphone access to run Genie Transcribe.',
                      true,
                      6000
                    )
                  );
                  return;
                }
              } catch (_) {
                // Permissions API not supported — continue and let getUserMedia handle it
              }

              resetAll();
              setLoading(true);
              if (setMeetingAPIDetails) {
                setMeetingAPIDetails({});
              }
              setDetails(meetingDetailsRef.current);
              navigate(ROUTES.HOME);
              setDialogOpen(false);
            }}
          >
            Resume
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}, (prevProps, nextProps) => {
  // Custom comparison function to prevent unnecessary rerenders
  return (
    prevProps.meeting?.id === nextProps.meeting?.id &&
    prevProps.meeting?.title === nextProps.meeting?.title &&
    prevProps.meeting?.duration === nextProps.meeting?.duration &&
    prevProps.isSelected === nextProps.isSelected &&
    prevProps.showCheckbox === nextProps.showCheckbox &&
    prevProps.swipedItemId === nextProps.swipedItemId
  );
});

// --- RecordingNowItem Component ---
// Separate component that handles its own timer subscription to prevent main list rerenders
const RecordingNowItem = React.memo(({
  meetingBase,
  formatTime,
  handleSoftDelete,
  setLoading,
  setDetails,
  setMeetingAPIDetails,
  navigate,
  dispatch,
  meetingHistoryData,
  transScriptSession,
}) => {
  // Subscribe to recordingTime only in this isolated component
  const recordingTime = useSelector(state => 
    state.currentMeetingDetails.isRecording 
      ? state.currentMeetingDetails.recordingTime 
      : 0
  );
  
  // Memoize the meeting object with updated duration
  const meeting = useMemo(() => ({
    ...meetingBase,
    duration: formatTime(recordingTime),
  }), [meetingBase, recordingTime, formatTime]);

  return (
    <Stack
      key={'Recording Now'}
      spacing={0}
      className={'recording-now-box'}
      sx={{
        '&.recording-now-box': {
          position: 'sticky',
          top: '0',
          zIndex: '11',
          '.MuiPaper-root': {
            backgroundColor: 'var(--grey-100)',
          },
        },
      }}
    >
      <Box sx={{ minWidth: `${MIN_ROW_WIDTH}px` }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            px: 2,
            py: 1.5,
            borderTop: '1px solid var(--grey-100)',
            borderBottom: '1px solid var(--grey-100)',
            background: 'var(--grey-50)',
          }}
        >
          <BlinkingDot />
          <Typography
            variant="caption"
            fontWeight={500}
            color="primary.300"
          >
            Recording Now
          </Typography>
        </Box>
        <MeetingItem
          meeting={meeting}
          handleSoftDelete={handleSoftDelete}
          setLoading={setLoading}
          setDetails={setDetails}
          setMeetingAPIDetails={setMeetingAPIDetails}
          navigate={navigate}
          isRecord={true}
          hasOngoingMeeting={true}
          dispatch={dispatch}
          meetingHistoryData={meetingHistoryData}
          transScriptSession={transScriptSession}
        />
      </Box>
    </Stack>
  );
}, (prevProps, nextProps) => {
  // Only rerender if the base meeting data changes (not the timer)
  return (
    prevProps.meetingBase?.id === nextProps.meetingBase?.id &&
    prevProps.meetingBase?.title === nextProps.meetingBase?.title &&
    prevProps.meetingBase?.startTime === nextProps.meetingBase?.startTime
  );
});

// --- MAIN COMPONENT ---
export default function TranscriberHistory(props) {
  // React Router hooks
  const navigate = useNavigate();
  const location = useLocation();

  // App Context for shared state
  const {
    details,
    setDetails,
    setMeetingAPIDetails,
    loading,
    setLoading,
    formatTime,
    formatDuration,
    formatDateTime,
  } = useAppContext();

  // Determine current route info
  const currentPath = location.pathname;
  const isOnHistoryRoute = currentPath === ROUTES.HISTORY;

  const [swipedItemId, setSwipedItemId] = useState(null);
  const [containerHeight, setContainerHeight] = useState(500);
  const listWrapperRef = useRef(null);
  const prevPathRef = useRef(currentPath);

  useEffect(() => {
     const updateHeight = () => {
        if (listWrapperRef.current) {
           setContainerHeight(listWrapperRef.current.clientHeight);
        }
     };
     updateHeight();
     window.addEventListener('resize', updateHeight);
     const observer = new ResizeObserver(updateHeight);
     if (listWrapperRef.current) observer.observe(listWrapperRef.current);
     return () => {
        window.removeEventListener('resize', updateHeight);
        observer.disconnect();
     };
  }, []);


  const transScriptSession = useSelector(
    state => state.sessionDetail.transScriptSession
  );
  const dispatch = useDispatch();
  const [triggerMeetingHistoryCall, setTriggerMeetingHistoryCall] =
    useState(false);
  const [meetingHistoryData, setMeetingHistoryData] = useState({ apiData: [] });
  const currentDate = dayjs();
  const [dataExists, setDataExists] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [transcriptOnlyToggle, setTranscriptOnlyToggle] = useState(false);
  const [selectedMeetings, setSelectedMeetings] = useState(new Set());
  const [openBulkDeleteDialog, setOpenBulkDeleteDialog] = useState(false);
  const [isSelectionMode, setIsSelectionMode] = useState(false);
  const { resetAll } = useTranscriber();

  const [dateValue, setDateValue] = useState([
    dayjs(currentDate.subtract(365, 'day')),
    currentDate,
  ]);
  
  // Selective useSelector - only subscribe to fields we need, excluding recordingTime
  // This prevents rerenders when only recordingTime changes
  const current_meeting = useSelector(
    state => ({
      id: state.currentMeetingDetails.id,
      isRecording: state.currentMeetingDetails.isRecording,
      meetingTitle: state.currentMeetingDetails.meetingTitle,
      start_time: state.currentMeetingDetails.start_time,
      credits_used: state.currentMeetingDetails.credits_used,
      meeting_id: state.currentMeetingDetails.meeting_id,
      lastAutoStopReason: state.currentMeetingDetails.lastAutoStopReason,
      stopped: state.currentMeetingDetails.stopped,
    }),
    (prev, next) => {
      // Custom equality check - only rerender if relevant fields change
      return (
        prev.id === next.id &&
        prev.isRecording === next.isRecording &&
        prev.meetingTitle === next.meetingTitle &&
        prev.start_time === next.start_time &&
        prev.credits_used === next.credits_used &&
        prev.meeting_id === next.meeting_id &&
        prev.lastAutoStopReason === next.lastAutoStopReason &&
        prev.stopped === next.stopped
      );
    }
  );

  const groupedMeetingData = useMemo(() => {
    var data = meetingHistoryData.apiData;
    if (meetingHistoryData.hasOwnProperty('searchResult')) {
      data = meetingHistoryData.searchResult;
    }
    if (transcriptOnlyToggle) {
      data = data.filter(ele => ele.status === 'transcript');
    }
    if (data && typeof data === 'object' && data.length > 0) {
      let grouped = groupMeetings(data);
      
      // Remove first meeting from first group when recording is active
      if (current_meeting?.isRecording && grouped.length > 0 && grouped[0].meetings.length > 0) {
        grouped[0].meetings = grouped[0].meetings.slice(1);
        // Remove the group entirely if it becomes empty
        if (grouped[0].meetings.length === 0) {
          grouped = grouped.slice(1);
        }
      }
      
      return grouped;
    } else {
      return [];
    }
  }, [meetingHistoryData, transcriptOnlyToggle, current_meeting?.isRecording]);

  // Clear selections when filters change
  useEffect(() => {
    setSelectedMeetings(new Set());
    setIsSelectionMode(false);
  }, [transcriptOnlyToggle]);

  // Show notification only for automatic inactivity stop (no summary dialog in that flow).
  // For manual stop / manual_inactivity, do NOT show here – the snackbar is shown only when
  // the user closes or submits the summary meeting dialog (AudioControl SummarizeDialog onClose).
  useEffect(() => {
    if (current_meeting?.stopped && current_meeting?.lastAutoStopReason === 'inactivity') {
      dispatch(
        openSnackbar(
          'warning',
          'Your last meeting was automatically stopped due to inactivity.'
        )
      );
      dispatch(
        setCurrentRecording({
          lastAutoStopReason: null,
        })
      );
    }
  }, [current_meeting?.lastAutoStopReason, current_meeting?.stopped, dispatch]);

  const [expandedGroups, setExpandedGroups] = useState(() => {
    const initial = {};
    groupedMeetingData.forEach(group => {
      initial[group.dateLabel] = true;
    });
    return initial;
  });

  const expandAll = () => {
    const allExpanded = {};
    groupedMeetingData.forEach(group => {
      allExpanded[group.dateLabel] = true;
    });
    setExpandedGroups(allExpanded);
    listRef.current?.resetAfterIndex(0);
  };

  useEffect(() => {
    expandAll();
  }, [groupedMeetingData]);

  const listRef = useRef();

  useEffect(() => {
    if (isOnHistoryRoute && transScriptSession) {
      fetchMeetingHistory(dateValue);
    }
    setTranscriptOnlyToggle(false);
    setSelectedMeetings(new Set());
  }, [isOnHistoryRoute, transScriptSession]);

  // Reset recording state only when user has just navigated TO history (not when they were already on history and stopped from PiP)
  // When stopping from PiP on history, we must not reset so the app can navigate to home and show the summary modal
  useEffect(() => {
    const justLandedOnHistory = prevPathRef.current !== ROUTES.HISTORY && isOnHistoryRoute;
    if (justLandedOnHistory && current_meeting?.stopped && !current_meeting?.isRecording) {
      // User navigated to history with meeting already stopped (e.g. after closing summary modal) – clear stale state
      dispatch(resetRecording());
    }
    prevPathRef.current = currentPath;
  }, [currentPath, isOnHistoryRoute, current_meeting?.stopped, current_meeting?.isRecording, dispatch]);

  // Memoize the base ongoing meeting object - only updates when relevant fields change
  // Return null instead of empty object when not recording to make checks easier
  const ongoingMeetingBase = useMemo(() => {
    if (!isOnHistoryRoute) return null;
    // Don't show ongoing meeting if recording is false OR if meeting is stopped
    if (!current_meeting?.isRecording || current_meeting?.stopped) return null;
    
    const obj = {
      id: current_meeting?.id,
      isRecording: current_meeting.isRecording,
      title: current_meeting.meetingTitle,
      startTime: current_meeting.start_time,
      dateLabel: 'Recording Now',
      creditsUsed: current_meeting.credits_used,
    };

    if (
      details.hasOwnProperty('meetingDetails') &&
      Object.keys(details.meetingDetails).length > 0
    ) {
      obj['hasInfo'] = true;
      obj['infoDetails'] = details.meetingDetails;
    }

    return obj;
  }, [
    isOnHistoryRoute,
    current_meeting?.id,
    current_meeting?.isRecording,
    current_meeting?.stopped,
    current_meeting?.meetingTitle,
    current_meeting?.start_time,
    current_meeting?.credits_used,
    details,
  ]);

  useEffect(() => {
    if (transScriptSession && triggerMeetingHistoryCall) {
      fetchMeetingHistory(dateValue);
    }
  }, [triggerMeetingHistoryCall]);

  const fetchMeetingHistory = async dateRange => {
    const url = `${API_URL}/api/history?start_date=${dateRange[0].format(
      'DD-MM-YYYY'
    )}&end_date=${dateRange[1].format('DD-MM-YYYY')}`;
    setLoading(true);
    try {
      const value = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${transScriptSession}`,
        },
      });
      if (value.data.length === 0) {
        setDataExists(false);
        return;
      }
      setDataExists(true);
      var data = value.data.map(ele => {
        var dateTime = formatDateTime(ele.date);
        var obj = {
          id: ele.id,
          isRecording: false,
          title: ele.title,
          duration: formatDuration(ele.duration),
          startTime: dateTime[1],
          dateLabel: dateTime[0],
          creditsUsed: ele.credits_used,
          hasInfo: Boolean(ele.parent_recording_id),
          status: Boolean(ele.has_mom) ? 'full' : 'transcript',
          infoDetails: {},
          parentRecordingId: ele.parent_recording_id,
        };
        return obj;
      });
      // Use the selective current_meeting which doesn't include recordingTime
      if (current_meeting?.isRecording && current_meeting?.meeting_id) {
        data = data.filter(
          ele => ele.id - 0 !== current_meeting.meeting_id - 0
        );
      }
      setMeetingHistoryData({ apiData: data });
      // setOngoingMeeting(data.length > 0 ? data[0] : {});
      setTriggerMeetingHistoryCall(false);
      setSelectedMeetings(new Set());
    } catch (err) {
      dispatch(
        openSnackbar(
          'error',
          'Something went wrong while fetching meeting list.'
        )
      );
      // Error while fetching meeting history
      setTriggerMeetingHistoryCall(false);
    } finally {
      setLoading(false);
      setHasFetched(true);
    }
  };

  const handleSearch = value => {
    var data = meetingHistoryData.apiData.filter(row => {
      var search = row.title.toLowerCase();
      return search.includes(value.toLowerCase()) && !row.isRecording;
    });
    setMeetingHistoryData(prev => ({ ...prev, ...{ searchResult: data } }));
    if (!value || value.trim() === '') {
      setSelectedMeetings(new Set());
    }
  };

  const handleSoftDelete = async meetingId => {
    const url = `${API_URL}/api/history`;
    setLoading(true);
    try {
      const value = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${transScriptSession}`,
        },
        data: {
          recording_ids: [meetingId],
          // recover: true,
        },
      });
      dispatch(openSnackbar('success', 'Meeting Deleted.'));
      setTriggerMeetingHistoryCall(true);
    } catch (err) {
      // Error while deleting meeting
      dispatch(
        openSnackbar('error', 'Something went wrong while deleting meeting.')
      );
      setTriggerMeetingHistoryCall(true);
    } finally {
      setLoading(false);
    }
  };

  const handleBulkDelete = async () => {
    const meetingIds = Array.from(selectedMeetings);
    if (meetingIds.length === 0) return;

    setLoading(true);
    try {
      // Single API call with all recording IDs for soft delete
      await axios.delete(`${API_URL}/api/history`, {
        headers: {
          Authorization: `Bearer ${transScriptSession}`,
          'Content-Type': 'application/json',
        },
        data: {
          recording_ids: meetingIds,
        },
      });

      dispatch(
        openSnackbar(
          'success',
          `${meetingIds.length} meeting(s) deleted successfully.`
        )
      );
      setSelectedMeetings(new Set());
      setIsSelectionMode(false);
      setOpenBulkDeleteDialog(false);
      setTriggerMeetingHistoryCall(true);
    } catch (err) {
      // Error while deleting meetings
      dispatch(
        openSnackbar('error', 'Something went wrong while deleting meetings.')
      );
      setTriggerMeetingHistoryCall(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectMeeting = useCallback((meetingId, isSelected) => {
    setSelectedMeetings(prev => {
      const newSet = new Set(prev);
      if (isSelected) {
        newSet.add(meetingId);
      } else {
        newSet.delete(meetingId);
      }
      // Enable selection mode if there are selected items
      if (newSet.size > 0) {
        setIsSelectionMode(true);
      } else {
        setIsSelectionMode(false);
      }
      return newSet;
    });
  }, []);

  const isMobileView = isMobile || isTablet;

  // Handle long-press to enable selection mode and select item
  const handleLongPress = useCallback((meetingId, event) => {
    if (!isMobileView) return;
    
    event?.preventDefault?.();
    event?.stopPropagation?.();
    
    // Enable selection mode
    setIsSelectionMode(true);
    
    // Select the item
    handleSelectMeeting(meetingId, true);
    
    // Provide haptic feedback if available
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }
  }, [isMobileView, handleSelectMeeting]);

  const handleSelectAll = useCallback((meetings, isSelected) => {
    setSelectedMeetings(prev => {
      const newSet = new Set(prev);
      if (isSelected) {
        meetings.forEach(meeting => {
          if (!meeting.isRecording) {
            newSet.add(meeting.id);
          }
        });
      } else {
        meetings.forEach(meeting => {
          newSet.delete(meeting.id);
        });
      }
      return newSet;
    });
  }, []);

  // Get all meetings (excluding recording now)
  const getAllMeetings = useMemo(() => {
    return groupedMeetingData.flatMap(group => group.meetings);
  }, [groupedMeetingData]);

  const allMeetingsSelected =
    getAllMeetings.length > 0 &&
    getAllMeetings.every(
      meeting => meeting.isRecording || selectedMeetings.has(meeting.id)
    );

  const someMeetingsSelected =
    getAllMeetings.some(
      meeting => !meeting.isRecording && selectedMeetings.has(meeting.id)
    ) && !allMeetingsSelected;

  const virtualRows = useMemo(() => {
    return groupedMeetingData.flatMap(({ dateLabel, meetings }) => {
      const rows = [{ type: 'header', dateLabel, meetings }];
      if (expandedGroups[dateLabel]) {
        rows.push(
          ...meetings.map(meeting => ({
            type: 'item',
            dateLabel,
            meeting,
          }))
        );
      }
      return rows;
    });
  }, [groupedMeetingData, expandedGroups]);

  const Row = ({ index, style, data }) => {
    const {
      data: listData,
      isOngoing,
      selectedMeetings,
      handleSelectMeeting,
      handleSelectAll,
      swipedItemId,
      setSwipedItemId,
    } = data;

    const row = listData[index];
 const ClickableWrapper = ({ children }) => {
      const commonStyles = {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        textAlign: 'left',
        minWidth: 0,
      };
      if (row.meeting.isRecording) {
        return <Box sx={commonStyles}>{children}</Box>;
      }

      return (
        <ButtonBase
          onClick={(e) => {
            e.stopPropagation(); // Prevent triggering parent clicks
            setLoading(true);
            setDetails({ meetingDetails: row.meeting, isResume: false, isDetailsView: true });
            navigate(ROUTES.MEETING(row.meeting.id));
          }}
          sx={commonStyles}
        >
          {children}
        </ButtonBase>
      );
    };

    
    if (row.type === 'header') {
      const isExpanded = expandedGroups[row.dateLabel];
      const groupMeetings = row.meetings || [];
      const nonRecordingMeetings = groupMeetings.filter(m => !m.isRecording);
      const selectedSet = selectedMeetings || new Set();
      const groupSelectedCount = nonRecordingMeetings.filter(m =>
        selectedSet.has(m.id)
      ).length;
      const allGroupSelected =
        nonRecordingMeetings.length > 0 &&
        groupSelectedCount === nonRecordingMeetings.length;
      const someGroupSelected =
        groupSelectedCount > 0 &&
        groupSelectedCount < nonRecordingMeetings.length;

      return (
        <div style={style}>
        <Box
           sx={{
              // minWidth: `${MIN_ROW_WIDTH}px`, // ADDED: Forces alignment with content
              minWidth: isMobileView ? '100%' : `${MIN_ROW_WIDTH}px`,
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              // px: 2,
                  paddingX: isMobile ?'8px' : 2, 
              gap: 1,
              background: 'var(--grey-50)',
              borderTop: '1px solid var(--grey-100)',
              borderBottom: '1px solid var(--grey-100)', 
              cursor: 'pointer',
              
            }}
        >
          {/* <Box display="flex" alignItems="center" gap={1}> */}
            {nonRecordingMeetings.length > 0 && (
              <Checkbox
                checked={allGroupSelected}
                indeterminate={someGroupSelected}
                onChange={e => {
                  e.stopPropagation();
                  handleSelectAll(groupMeetings, e.target.checked);
                }}
                onClick={e => e.stopPropagation()}
                size="small"
              />
            )}
            <Typography
              variant="caption"
              fontWeight={500}
              onClick={() => {
                setExpandedGroups(prev => {
                  const updated = {
                    ...prev,
                    [row.dateLabel]: !prev[row.dateLabel],
                  };

                  // Reset list heights after DOM updates
                  setTimeout(() => {
                    listRef.current?.resetAfterIndex(0);
                  }, 0);

                  return updated;
                });
              }}
              sx={{ flex: 1 }}
            >
              {row.dateLabel}
              {nonRecordingMeetings.length > 0 && groupSelectedCount > 0 && (
                <Typography
                  component="span"
                  variant="caption"
                  sx={{ ml: 1, color: 'text.secondary' }}
                >
                  ({groupSelectedCount})
                </Typography>
              )}
            </Typography>
            <Tooltip title={isExpanded ? 'Collapse' : 'Expand'} arrow>
              <IconButton
                size="small"
                onClick={e => {
                  e.stopPropagation();
                  setExpandedGroups(prev => {
                    const updated = {
                      ...prev,
                      [row.dateLabel]: !prev[row.dateLabel],
                    };

                    // Reset list heights after DOM updates
                    setTimeout(() => {
                      listRef.current?.resetAfterIndex(0);
                    }, 0);

                    return updated;
                  });
                }}
              >
                <ExpandMoreIcon
                  sx={{
                    transform: expandedGroups[row.dateLabel]
                      ? 'rotate(0deg)'
                      : 'rotate(-90deg)',
                    transition: 'transform 0.2s ease-in-out',
                  }}
                />
              </IconButton>
            </Tooltip>
          {/* </Box> */}
        </Box>
        </div>
      );
    }

    return (
      <div
      style={style}
      className="meeting-item-test"
    >
        {!isMobileView ? (
          <Collapse in={true} timeout="auto" sx={{ width: '100%' }}>
            <MeetingItem
              meeting={row.meeting}
              handleSoftDelete={handleSoftDelete}
              props={props}
              setLoading={setLoading}
              setDetails={setDetails}
              setMeetingAPIDetails={setMeetingAPIDetails}
              navigate={navigate}
              isRecord={false}
              hasOngoingMeeting={isOngoing}
              dispatch={dispatch}
              meetingHistoryData={meetingHistoryData}
              resetAll={resetAll}
              isSelected={
                selectedMeetings ? selectedMeetings.has(row.meeting.id) : false
              }
              onSelectChange={handleSelectMeeting}
              showCheckbox={true}
              transScriptSession={transScriptSession}
              setTriggerMeetingHistoryCall={setTriggerMeetingHistoryCall}
              // IMPORTANT: Pass these new props for Mobile Swipe to work
              swipedItemId={swipedItemId}
              setSwipedItemId={setSwipedItemId}
            />
          </Collapse>
        ) : (
          <MeetingItem
            meeting={row.meeting}
            handleSoftDelete={handleSoftDelete}
            props={props}
            setLoading={setLoading}
            setDetails={setDetails}
            setMeetingAPIDetails={setMeetingAPIDetails}
            navigate={navigate}
            isRecord={false}
            hasOngoingMeeting={isOngoing}
            dispatch={dispatch}
            meetingHistoryData={meetingHistoryData}
            resetAll={resetAll}
            isSelected={
              selectedMeetings ? selectedMeetings.has(row.meeting.id) : false
            }
            onSelectChange={handleSelectMeeting}
            showCheckbox={true}
            onLongPress={handleLongPress}
            transScriptSession={transScriptSession}
            setTriggerMeetingHistoryCall={setTriggerMeetingHistoryCall}
            // IMPORTANT: Pass these new props for Mobile Swipe to work
            swipedItemId={swipedItemId}
            setSwipedItemId={setSwipedItemId}
          />
        )}
      </div>
    );
  };

  const handleDateChange = e => {
    setDateValue(e);
    fetchMeetingHistory(e);
  };
  // const getItemSize = index => {
  //   const row = virtualRows[index];
  //   //return row.type === "header" ? 40 : 60; // adjust heights as needed
  //   const currentWidth = window.innerWidth;

  //   if (row.type === 'header') {
  //     return 40;
  //   } else {
  //     if (currentWidth < 600) {
  //       return 140;
  //     } else if (currentWidth < 960) {
  //       return 80;
  //     } else {
  //       return 60;
  //     }
  //   }
  // };

   const getItemSize = index => {
    const row = virtualRows[index];
    if (row.type === 'header') return 40;
    if (isMobileView) {
      return row.meeting?.status === 'transcript' ? 95 : 65; 
    }
    return 60;
  };

  // Memoize itemData for virtual list - must be at top level (not conditional)
  const itemData = useMemo(() => ({
    data: virtualRows,
    isOngoing: ongoingMeetingBase !== null,
    selectedMeetings,
    handleSelectMeeting,
    swipedItemId,
    setSwipedItemId,
    handleSelectAll,
  }), [virtualRows, ongoingMeetingBase, selectedMeetings, swipedItemId, handleSelectMeeting, handleSelectAll, setSwipedItemId]);

  // Auto-open PiP when user navigates to this page
  // useEffect(() => {
  //   if (isPiPSupported && !isPiPOpen) {
  //     // Small delay to ensure the page has loaded
  //     const timer = setTimeout(() => {
  //       openPiP({ width: 400, height: 500 });
  //     }, 500);

  //     return () => clearTimeout(timer);
  //   }
  // }, [location.pathname, isPiPSupported, isPiPOpen, openPiP]);

  return (
    <Box
      sx={{
        // p: {xs: 2, md: 3},
        // backgroundColor: '#f0f4ff', // Main light blue background
        // borderRadius: 4,
        // boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
        // border: '1px solid #e0e7ff',
        // maxWidth: 1200,
        // margin: 'auto',
        width: '100%',
        height: {
          // xs: ['calc(100vh - 116px)', 'calc(100dvh - 116px)'],
          // sm: ['calc(100vh - 145px)', 'calc(100dvh - 145px)'],
        },
        overflow: 'hidden',
      }}
    >
      {/* for the desktop view */}
      <Stack height={'100%'}>
        {/* Top Bar: Search and Actions */}
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 12,
            backgroundColor: 'var(--grey-0)',
            borderBottom: '1px solid var(--grey-100)',
          }}
        >
          <Box
            display={'flex'}
            alignItems={'center'}
            sx={{
              m: { xs: 0, md: 3 },
              mb: { xs: 0, md: 2 },
              px: 2,
              py: 0.5,
              gap: { xs: 1, md: 2 },
              background: { xs: 'transparent', md: 'var(--grey-0)' },
              border: '1px solid var(--grey-100)',
              borderRadius: { xs: 0, md: '10px' },
              // borderBottom:  '1px solid var(--grey-100)' ,
            }}
          >
            <TextField
              id="transcriber-history-search"
              name="searchMeetings"
              fullWidth
              variant="standard"
              placeholder="Search meetings title here..."
              onChange={e => {
                const value = e.target.value.trim() || '';
                if (value && value.length > 0) {
                  handleSearch(value);
                } else {
                  setMeetingHistoryData({
                    apiData: meetingHistoryData.apiData,
                  });
                }
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                },
              }}
              type="search"
              size="small"
              sx={{
                '& .MuiInputBase-input': {
                  padding: 0,
                },
                '& .MuiInput-underline:before': {
                  borderBottom: 'none',
                },
                '& .MuiInput-underline:after': {
                  borderBottom: 'none',
                },
                '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                  borderBottom: 'none',
                },
              }}
            />
            <Box display={'flex'} alignItems={'center'} gap={1}>
              <Tooltip title="Show Transcript Only" arrow>
                <Switch
                  checked={transcriptOnlyToggle}
                  onChange={e => {
                    setTranscriptOnlyToggle(e.target.checked);
                  }}
                  size="small"
                />
              </Tooltip>
              <Tooltip title="Refresh" arrow>
                <IconButton size="small">
                  <RefreshIcon
                    onClick={() => {
                      setTriggerMeetingHistoryCall(true);
                    }}
                  />
                </IconButton>
              </Tooltip>
              {/* <IconButton size="small"> */}
              <CustomDateRangePicker
                value={dateValue}
                setDateRangeValue={handleDateChange}
              />
              {/* </IconButton> */}
            </Box>
          </Box>
          {ongoingMeetingBase && (
            <RecordingNowItem
              meetingBase={ongoingMeetingBase}
              formatTime={formatTime}
              handleSoftDelete={handleSoftDelete}
              setLoading={setLoading}
              setDetails={setDetails}
              setMeetingAPIDetails={setMeetingAPIDetails}
              navigate={navigate}
              dispatch={dispatch}
              meetingHistoryData={meetingHistoryData}
              transScriptSession={transScriptSession}
            />
          )}
          {/* Select All and Bulk Actions */}
          {getAllMeetings.length > 0 && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                // px: 2,
                paddingX: isMobile ? '8px' : 2,
                py: isMobile ? 0 : 1,
                // py: 1,
                borderBottom: '1px solid var(--grey-100)',
                backgroundColor: 'var(--grey-0)',
              }}
            >
              <Checkbox
                checked={allMeetingsSelected}
                indeterminate={someMeetingsSelected}
                onChange={e => {
                  handleSelectAll(getAllMeetings, e.target.checked);
                }}
                size="small"
              />
              <Typography variant="body2" color="text.primary">
                Select All ({selectedMeetings.size})
              </Typography>
              {selectedMeetings.size > 0 && (
                <>
                  <Box sx={{ ml: 'auto', display: 'flex', gap: 0.5 }}>
                    <Tooltip title="Delete Selected" arrow>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setOpenBulkDeleteDialog(true);
                        }}
                        sx={{ color: 'error.main' }}
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </>
              )}
            </Box>
          )}
        </Box>

        {/* Meetings List by Date */}

        <Box
          ref={listWrapperRef}
          sx={{
            flex: 1,
            width: '100%',
            // overflowY: 'scroll', 
            overflowX: 'auto',
          }}
        >
          {dataExists ? (

            <Stack sx={{ height: '100%', flex: '1 1 auto' }}>
              <List
                ref={listRef}
                height={window.innerHeight - 64} // Adjust based on sticky top bar
                itemCount={virtualRows.length}
                itemSize={getItemSize}
                width="100%"
                itemData={itemData}
              //  style={{ overflowX: 'auto', overflowY: 'auto' }}
              >
                {Row}
              </List>
            </Stack>

          ) : (
            !loading && hasFetched && (
              <Box
                sx={{
                  justifyContent: 'center',
                  alignContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  display: 'flex',
                  width: '100%',
                }}
              >
                {/* <Typography vertical="body2" color={'text.primary'}>
                  <b>No Records Found</b>
                </Typography> */}
                <img
                  src={norecordsfound}
                  style={{ minWidth: '100px', maxWidth: '60%' }}
                />
              </Box>
            )
          )}
        </Box>

        {/* <Stack sx={{ height: '100%', overflow: 'auto', flex: '1 1 auto' }}>
          {groupedMeetingData.map(({ dateLabel, meetings }) => (
            <Stack
              key={dateLabel}
              spacing={0}
              className={undefined}
              sx={{
                "&.recording-now-box": {
                  position: "sticky",
                  top: "0",
                  zIndex: "11",
                  ".MuiPaper-root": {
                    backgroundColor: 'var(--grey-100)',
                  }
                }
              }}
            >
              <Box
                sx={{
                  px: 2,
                  py: 1.5,
                  borderTop: '1px solid var(--grey-100)',
                  borderBottom: '1px solid var(--grey-100)',
                  background: 'var(--grey-50)',
                  position: "sticky",
                  top: 0,
                  zIndex: "1"
                }}
              >
                <Typography variant="caption" color="text.primary">
                  {dateLabel}
                </Typography>
              </Box>
              <Stack>
                {meetings.map((meeting) => (
                  <MeetingItem key={meeting.id} meeting={meeting} handleSoftDelete={handleSoftDelete} />
                ))}
              </Stack>
            </Stack>
          ))}
        </Stack> */}
      </Stack>

      {/* Bulk Delete Confirmation Dialog */}
      <Dialog
        open={openBulkDeleteDialog}
        onClose={() => setOpenBulkDeleteDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography
            variant="subtitle1"
            component={'span'}
            color="text.primary"
          >
            Are you sure you want to continue?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.primary">
            {selectedMeetings.size === 1 ? (
              <>1 meeting will be deleted.</>
            ) : (
              <>{selectedMeetings.size} meetings will be deleted.</>
            )}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenBulkDeleteDialog(false);
            }}
          >
            Cancel
          </Button>
          <Button color="error" variant="contained" onClick={handleBulkDelete}>
            DELETE
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
